	<template>
	<div>

		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack(false)"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

		    <v-toolbar-title class="white--text">Ledger</v-toolbar-title>

		    <!-- <v-spacer></v-spacer>

		    <v-btn round-borders outline @click="fn_checkValidations">save</v-btn> -->

		    <!-- <v-btn icon @click="fn_getBottomMenu">
		      <v-icon>more_vert</v-icon>
		    </v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasToolbar hasFooter">

			
			<!-- <v-alert :value="true" color="info" class="draft-items-info" transition="slide-y-transition" v-if="Form.draftItems && Form.draftItems.length"@click="fn_openDialogDraftItems">
				<span>Draft Items</span>
				<span class="right-side-content">{{Form.draftItems.length}}</span>
			</v-alert> -->

			<!-- <v-alert :value="loadedFromDraft" type="warning" icon="info" transition="slide-y-transition">
				<span>Item loaded from draft.</span>
			</v-alert> -->

			<v-layout wrap class="form_wrapper">

				<v-layout wrap class="section-wrapper">

					<v-flex xs12 sm12 md12 form-item>
		               	<v-radio-group v-model="Form.groupTypeId" row @change="fn_groupTypeChange">
					      <v-radio label="Customer" :value="101"></v-radio>
					      <v-radio label="Supplier" :value="102"></v-radio>
					      <v-radio label="Other" :value="103"></v-radio>
					      <v-radio label="Branch/Division" :value="104" v-if="$root.TransactionSettings.branchDivision"></v-radio>
					    </v-radio-group>
		            </v-flex>

		            <!-- <v-flex xs10 sm10 md10 form-item>
		               <v-text-field  
		               	v-model="Form.name" 
		               	:label="fn_getNameLabel()"
		               	placeholder=" " 
		               	v-validate="'required|max:50'" 
		               	:error-messages="errors.collect('name')" 
		               	append-icon="import_contacts" 
		               	:append-icon-cb="fn_showContactList" 
		               	data-vv-name="name" 
		               	required>
		               	</v-text-field>
		            </v-flex> -->

		            <v-flex xs12 sm12 md12 pl-3 :class="{'pr-3':Form.groupTypeId==103}">
		            	<v-btn icon flat color="primary" @click="fn_showContactList" style="float: right;margin-left: 16px;" v-if="Form.groupTypeId!=103"><v-icon>import_contacts</v-icon></v-btn>
		            	
		               <v-text-field  
		               	v-model="Form.name" 
		               	:label="fn_getNameLabel()"
		               	placeholder=" " 
		               	v-validate="'required|max:100'" 
		               	:error-messages="errors.collect('name')" 
		               	data-vv-name="name" 
		               	required>
		               	</v-text-field>
		            </v-flex>

		            <!-- <v-flex xs2 sm2 md2 pr-3 v-if="Form.groupTypeId != 103">
		            	<v-btn icon @click="fn_showContactList"><v-icon>import_contacts</v-icon></v-btn>   
		            </v-flex> -->

		             <v-flex xs12 sm12 md12 form-item @click="fn_openAccountGroupsDialog('android', 'AccountGroups', 'field_accountGroups')">

		                <v-text-field  
		               		readonly
		               		v-model="Form.accountGroupName" 
		               		label="Account Group" 
		               		placeholder=" "
		               		append-icon="arrow_drop_down"
		               		ref="field_accountGroups" 
			               	:onUpdate="fn_updateAccountGroup"
			               	v-validate="'required'" 
			               	:error-messages="errors.collect('account group')" 
			               	data-vv-name="account group" 
			               	required>
		               	</v-text-field>

		            </v-flex>

					<!-- <v-flex xs12 sm12 md12 form-item v-if="Form.groupTypeId==102">
		               <v-text-field  
							type="number"
			               	v-model="Form.aadharNumber" 
			               	label="Aadhar Number"
			               	placeholder=" ">
		               </v-text-field>
		            </v-flex> -->

		            <v-flex xs12 sm12 md12 form-item @click="fn_openRoutes('android', 'Route', 'field_routes')" v-if="Form.groupTypeId==101 && $root.TransactionSettings.beatRouteArea">
		            <!-- <v-flex xs12 sm12 md12 form-item @click="fn_openRoutes('android', 'Route', 'field_routes')"> -->

		               	<v-text-field  
		               		readonly
		               		v-model="Form.routeName" 
		               		label="Beat/Area/Route" 
		               		placeholder=" "
		               		append-icon="arrow_drop_down"
		               		ref="field_routes" 
		               		:onUpdate="fn_updateRoute">
		               	</v-text-field>
		               	
		            </v-flex>
				</v-layout>

				<v-layout wrap v-if="Form.groupTypeId!=103" class="has-subheader section-wrapper contact-section">

	            	<v-subheader form-section-header form-item>Contact
	            		<v-spacer></v-spacer>
	            	</v-subheader>

	            	<div padding-top-ten full-width>
	            		<v-flex xs12 sm12 md12 form-item prepend-text>
			            		
			               	<v-text-field  
			               		label="Mobile Number" 
			               		placeholder=" " 
			               		type="tel" 
			               		v-model="Form.primaryMobileNumber">
			               	</v-text-field>

			            </v-flex>

			            <v-flex xs12 sm12 md12 form-item>
			               	<v-text-field  
			               		label="Email" 
			               		placeholder=" " 
			               		type="email" 
			               		v-model="Form.email" 
			               		v-validate="'email'" 
			               		data-vv-name="email" 
			               		:error-messages="errors.collect('email')">
			               	</v-text-field>
			            </v-flex>

	            	</div>

	            </v-layout>

	            <v-layout wrap white-background margin-bottom-ten>

	            	<div padding-top-ten full-width>
	            		<v-flex xs12 sm12 md12 form-item prepend-text @click="fn_openDialogOpening">
			            		
			               	<v-text-field  
			               		:append-outer-icon="Form.openingAmount ? 'close' : ''"
			               		@click:append-outer="Form.openingAmount=null"
			               		readonly
			               		append-icon="arrow_drop_down"
			               		prefix="₹"
			               		:label="fn_openingLabel()" 
			               		placeholder=" " 
			               		type="number" 
			               		:value="Form.openingAmount">
			               	</v-text-field>

			            </v-flex>
	            	</div>

	            </v-layout>

				<v-layout row wrap white-background margin-bottom-ten v-if="$root.appVersion >= 109 && Form.groupTypeId!=103">
					<div padding-top-ten full-width>
						<v-flex xs12 sm12 md12 form-item>
							<v-text-field  
								label="MSME/Udyam No" 
								placeholder=" "  
								v-model="Form.msmeUdyamNumber">
							</v-text-field>
						 </v-flex>
					</div>
				</v-layout>

	            <v-layout wrap nopadding full-width v-if="Form.groupTypeId!=103" class="section-wrapper has-subheader">
	              	<v-list subheader nopadding two-line full-width>

	              		<v-subheader class="gstdetails pr-0">GST Details
		            		<v-spacer></v-spacer>
		            		<v-btn flat icon color="primary" @click.native="fn_openDialogGstDetails" v-if="!Form.gstType">Add</v-btn>
		            		<v-btn flat icon color="primary" @click.native="fn_editGstDetails" v-else>Edit</v-btn>
		            	</v-subheader>

		            	<v-divider></v-divider>

		            	<div v-if="Form.gstType && (Form.gstType != 104 || (Form.gstType == 104 || Form.placeOfSupply))" full-width>
		            		
		            		<div v-if="Form.gstType">
		            			<v-list-tile>
						          	<v-list-tile-content>
						          		<v-list-tile-sub-title>GST Type</v-list-tile-sub-title>
						              	<v-list-tile-title>{{fn_getGstTypeName(Form.gstType)}}</v-list-tile-title>
						            </v-list-tile-content>
							    </v-list-tile>

							    <v-divider></v-divider>
		            		</div>

		            		<div v-if="Form.placeOfSupply">
		            			<v-list-tile>
						          	<v-list-tile-content>
						              	<v-list-tile-sub-title>State/Place of Supply</v-list-tile-sub-title>
						              	<v-list-tile-title>{{Form.placeOfSupply}}</v-list-tile-title>
						            </v-list-tile-content>
							    </v-list-tile>

						    	<v-divider></v-divider>
		            		</div>

						    <div v-if="Form.gstNumber">
						    	<v-list-tile>
						          	<v-list-tile-content>
						          		<v-list-tile-sub-title>GST Number</v-list-tile-sub-title>
						              	<v-list-tile-title>{{Form.gstNumber}}</v-list-tile-title>
						            </v-list-tile-content>
							    </v-list-tile>

							    <v-divider></v-divider>
						    </div>

						    <div v-if="Form.panNumber">
						    	<v-list-tile>
						          	<v-list-tile-content>
						          		<v-list-tile-sub-title>PAN Number</v-list-tile-sub-title>
						              	<v-list-tile-title>{{Form.panNumber}}</v-list-tile-title>
						            </v-list-tile-content>
							    </v-list-tile>

						    	<v-divider></v-divider>
						    </div>

							 <div v-if="Form.aadharNumber">
						    	<v-list-tile>
						          	<v-list-tile-content>
						          		<v-list-tile-sub-title>PAN Number</v-list-tile-sub-title>
						              	<v-list-tile-title>{{Form.aadharNumber}}</v-list-tile-title>
						            </v-list-tile-content>
							    </v-list-tile>

						    	<v-divider></v-divider>
						    </div>

						    <div v-if="Form.country">
						    	<v-list-tile>
						          	<v-list-tile-content>
						              	<v-list-tile-sub-title>Country</v-list-tile-sub-title>
						              	<v-list-tile-title>{{Form.country}}</v-list-tile-title>
						            </v-list-tile-content>
							    </v-list-tile>

						    	<v-divider></v-divider>
						    </div>

						    <!-- <v-list-tile v-if="Form.currency">
					          	<v-list-tile-content>
					              <v-list-tile-title>Currency</v-list-tile-title>
					              <v-list-tile-sub-title>{{Form.currency}}</v-list-tile-sub-title>
					            </v-list-tile-content>
						    </v-list-tile> -->
		            	</div>

				    </v-list>
	            </v-layout>

	            <v-layout nopadding wrap full-width class="section-wrapper" v-if="Form.groupTypeId!=103">

					<v-subheader class="pr-0 full-width" style="border-bottom: 1px #ddd solid;">Billing Address
						<v-spacer></v-spacer>
						<v-btn flat icon color="primary" @click.native="fn_addAddress(101)" v-if="!Form.billingAddress.length">Add</v-btn>
					</v-subheader>

					<template full-width v-for="(address, index) in Form.billingAddress">
						<v-layout row wrap full-width :key="index">
							<v-flex xs10 sm10 md10 pl-3 style="align-items: center;display: flex;">
								<div>{{fn_mergeAddress(address, 101)}}</div>
								<!-- <div><span v-if="address.isDefault" class="light-opacity-color">Default</span> <v-btn capitalize small class="pl-0 ml-0" flat color="primary" @click="fn_setDefaultAddress(index)" v-if="!address.isDefault">Set Default</v-btn></div> -->
							</v-flex>
							<v-flex xs2 sm2 md2 right-align>
								<v-menu>
									<v-btn slot="activator" icon>
									<v-icon>more_vert</v-icon>
									</v-btn>

									<v-list nopadding>
									<v-list-tile @click="fn_editAddress(address, 101)">
										<v-list-tile-title>Edit</v-list-tile-title>
									</v-list-tile>
									<v-list-tile @click="fn_removeAddress(index, 101)">
										<v-list-tile-title>Remove</v-list-tile-title>
									</v-list-tile>
									</v-list>

								</v-menu>
							</v-flex>
						</v-layout>
					</template>

	              	<!-- <v-list two-line full-width nopadding>	
		            	<v-subheader class="pr-0">Billing Address
		            		<v-spacer></v-spacer>
							<v-btn flat icon color="primary" @click.native="fn_addAddress(101)">Add</v-btn>
		            	</v-subheader>

		            	<v-divider v-if="Form.billingAddress && Form.billingAddress.length"></v-divider>

				        <template v-if="Form.billingAddress && Form.billingAddress.length">

				        	<v-list-tile v-for="(address, index) in Form.billingAddress" :key="index">
					          	<v-list-tile-content>
									  <v-list-tile-title>{{fn_mergeAddress(address, 101)}}</v-list-tile-title>
									  <v-list-tile-sub-title @click="fn_setDefaultAddress(index)"> <span v-if="address.isDefault">Default</span> <v-btn flat color="primary">Set Default</v-btn></v-list-tile-sub-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
					              <v-menu>
								      <v-btn slot="activator" icon>
								      	<v-icon>more_vert</v-icon>
								      </v-btn>

								      <v-list nopadding>
										<v-list-tile @click="fn_editAddress(address, 101)">
								          <v-list-tile-title>Edit</v-list-tile-title>
								        </v-list-tile>
								        <v-list-tile @click="fn_removeAddress(index, 101)">
								          <v-list-tile-title>Remove</v-list-tile-title>
								        </v-list-tile>
								      </v-list>

								    </v-menu>
						          </v-list-tile-action>
						    </v-list-tile>
				        </template>
					    
				    </v-list> -->
	            </v-layout>

				<v-layout nopadding wrap full-width class="section-wrapper" v-if="Form.groupTypeId!=103">

					<v-subheader class="pr-0 full-width" style="border-bottom: 1px #ddd solid;">Shipping Address
						<v-spacer></v-spacer>
						<v-btn flat icon color="primary" @click.native="fn_addAddress(102)">Add</v-btn>
					</v-subheader>

					<template full-width v-for="(address, index) in Form.shippingAddress">
						<v-layout row wrap full-width :key="index" mt-2>
							<v-flex xs10 sm10 md10 pl-3 style="justify-content: center;display: flex;flex-direction: column;">
								<div>{{fn_mergeAddress(address, 102)}}</div>
								<div><span v-if="address.isDefault" class="light-opacity-color">Default</span></div>
							</v-flex>
							<v-flex xs2 sm2 md2 right-align>
								<v-menu>
									<v-btn slot="activator" icon>
									<v-icon>more_vert</v-icon>
									</v-btn>

									<v-list nopadding>
										<v-list-tile @click="fn_setDefaultAddress(index)">
											<v-list-tile-title>Set Default</v-list-tile-title>
										</v-list-tile>
										<v-list-tile @click="fn_editAddress(address, 102)">
											<v-list-tile-title>Edit</v-list-tile-title>
										</v-list-tile>
										<v-list-tile @click="fn_removeAddress(index, 102)">
											<v-list-tile-title>Remove</v-list-tile-title>
										</v-list-tile>
									</v-list>

								</v-menu>
							</v-flex>
						</v-layout>
					</template>

					<!-- <v-list two-line full-width nopadding>	
						<v-subheader class="pr-0">Billing Address
							<v-spacer></v-spacer>
							<v-btn flat icon color="primary" @click.native="fn_addAddress(101)">Add</v-btn>
						</v-subheader>

						<v-divider v-if="Form.billingAddress && Form.billingAddress.length"></v-divider>

						<template v-if="Form.billingAddress && Form.billingAddress.length">

							<v-list-tile v-for="(address, index) in Form.billingAddress" :key="index">
								<v-list-tile-content>
									<v-list-tile-title>{{fn_mergeAddress(address, 101)}}</v-list-tile-title>
									<v-list-tile-sub-title @click="fn_setDefaultAddress(index)"> <span v-if="address.isDefault">Default</span> <v-btn flat color="primary">Set Default</v-btn></v-list-tile-sub-title>
								</v-list-tile-content>

								<v-list-tile-action>
								<v-menu>
									<v-btn slot="activator" icon>
										<v-icon>more_vert</v-icon>
									</v-btn>

									<v-list nopadding>
										<v-list-tile @click="fn_editAddress(address, 101)">
										<v-list-tile-title>Edit</v-list-tile-title>
										</v-list-tile>
										<v-list-tile @click="fn_removeAddress(index, 101)">
										<v-list-tile-title>Remove</v-list-tile-title>
										</v-list-tile>
									</v-list>

									</v-menu>
								</v-list-tile-action>
							</v-list-tile>
						</template>
						
					</v-list> -->
					</v-layout>

	            <!-- <v-layout nopadding wrap full-width class="section-wrapper" v-if="Form.groupTypeId!=103">
	              	<v-list full-width nopadding>	
		            	<v-subheader class="pr-0">Shipping Address
		            		<v-spacer></v-spacer>
							<v-btn flat icon color="primary" @click.native="fn_addAddress(102)">Add</v-btn>
		            	</v-subheader>

		            	<v-divider v-if="Form.shippingAddress && Form.shippingAddress.length"></v-divider>

				        <div class="addressListItem" v-if="Form.shippingAddress && Form.shippingAddress.length">

				        	<v-list-tile v-for="(address, index) in Form.shippingAddress" :key="index">
					          	<v-list-tile-content>
					              	<v-list-tile-title>{{fn_mergeAddress(address, 102)}}</v-list-tile-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
					              <v-menu>
								      <v-btn slot="activator" icon>
								      	<v-icon>more_vert</v-icon>
								      </v-btn>

								      <v-list nopadding>
										<v-list-tile @click="fn_editAddress(address, 102)">
								          <v-list-tile-title>Edit</v-list-tile-title>
								        </v-list-tile>
								        <v-list-tile @click="fn_removeAddress(index, 102)">
								          <v-list-tile-title>Remove</v-list-tile-title>
								        </v-list-tile>
								      </v-list>

								    </v-menu>
						          </v-list-tile-action>
						    </v-list-tile>
				        </div>
					    
				    </v-list>
	            </v-layout> -->

	           <!--  <v-layout nopadding wrap full-width class="section-wrapper" v-if="Form.groupTypeId!=103">
	              	<v-list two-line full-width nopadding>	
		            	<v-subheader class="pr-0">Address
		            		<v-spacer></v-spacer>
		            		<v-btn flat icon color="primary" @click.native="fn_addAddress">
		            			Add
		            		</v-btn>
		            	</v-subheader>

		            	<v-divider v-if="Form.addresses && Form.addresses.length"></v-divider>

				        <div v-for="(address, index) in Form.addresses" :key="index" class="addressListItem">

				        	<v-list-tile>
					          	<v-list-tile-content>
					          		<v-list-tile-sub-title>
					          			{{address.groupTypeId == 101 ? 'Billing Address' : address.groupTypeId == 102 ? 'Shipping Address' : 'Billing and Shipping Address' }}
					          		</v-list-tile-sub-title>
					              	<v-list-tile-title>{{fn_mergeAddress(address)}}</v-list-tile-title>
					            </v-list-tile-content>

					            <v-list-tile-action>
					              <v-menu>
								      <v-btn slot="activator" icon>
								      	<v-icon>more_vert</v-icon>
								      </v-btn>

								      <v-list nopadding>
								        <v-list-tile @click="fn_editAddress(address)">
								          <v-list-tile-title>Edit</v-list-tile-title>
								        </v-list-tile>

								        <v-divider></v-divider>

								        <v-list-tile @click="fn_removeAddress(address.addressId, index)">
								          <v-list-tile-title>Remove</v-list-tile-title>
								        </v-list-tile>
								      </v-list>

								    </v-menu>
						          </v-list-tile-action>
						    </v-list-tile>
						    <v-divider v-if="Form.addresses.length-1 != index"></v-divider>
				        </div>
					    
				    </v-list>
	            </v-layout> -->

	           <!-- <v-expansion-panel v-if="Form.groupTypeId!=103">
			  	<v-expansion-panel-content>
			        <v-subheader nopadding slot="header">Print Details</v-subheader>

			        <v-divider></v-divider>

			      	<v-card>
			        	<v-layout row wrap padding-top-bottom-ten>
			        		<v-flex xs12 sm12 md12 form-item>
				               <v-text-field  label="Name" placeholder=" " v-model="Form.printDetails.printName" @input="printFieldChanged=true"></v-text-field>
				            </v-flex>
			        	</v-layout>
			      	</v-card>
			    </v-expansion-panel-content>
			</v-expansion-panel> -->
				
			    
			</v-layout>

			<!-- {{Form.dynamicFields}} -->
			<div full-width v-if="Form.dynamicFields">
				<component-dynamic-fields ref="ref_componentDynamicFields" :openAccountLedgers="fn_openAccountLedgers" :openListItems="fn_openListItems" :openDatePicker="fn_openDatePicker" :dynamicFields="Form.dynamicFields"></component-dynamic-fields>
				<!-- <component-dynamic-fields ref="ref_componentDynamicFields" :openAccountLedgers="$parent.fn_openAccountLedgers" :openListItems="$parent.fn_openListItems" :openDatePicker="$parent.fn_openDatePicker" :dynamicFields="product.customFields"></component-dynamic-fields> -->
			</div>

			<!-- {{ Form.customFields }}
			<div full-width v-for="(dItem, dIndex) in Form.customFields" :key="dIndex">
				<v-list nopadding white-background>
					<v-list-tile>
						<v-list-tile-content>
							<v-list-tile-title>{{dItem.section.sectionName}}</v-list-tile-title>
						</v-list-tile-content>
					</v-list-tile>
				</v-list>

				<div class="pb-3" white-background full-width v-for="(item, index) in dItem.fields" :key="index" v-if="dItem.section.sectionId == item.sectionId" :class="{'margin-top-bottom-five':dItem.section.sectionId == item.sectionId}">
					<v-list nopadding :id="'section_'+item.sectionId">
						<v-list-tile>
							<v-list-tile-action>
								<v-btn icon @click="fn_removeFields(index, item.sectionId)">
									<v-icon>close</v-icon>
								</v-btn>
							</v-list-tile-action>

							<v-list-tile-content full-width>
								<v-list-tile-title>{{item.displayName}}</v-list-tile-title>
								<v-icon style="position:absolute;right:16px">keyboard_arrow_right</v-icon>
							</v-list-tile-content>
						</v-list-tile>
					</v-list>

					<v-divider></v-divider>

						<v-card flat v-if="item.value">
						<v-card-text class="pb-0">
							<div font12 light-theme-color>{{item.displayName}}</div>
							<div font16 v-if="item.fieldType=='yes/no'">{{item.value ? 'Yes' : 'No'}}</div>

							<div font16 v-else-if="item.fieldType=='dateTime'">
								<span v-if="item.value">{{item.value | moment("DD-MMM-YYYY")}}</span>
								<span v-else>-</span>
							</div>

							<div font16 v-else v-html="item.value ? item.value : '-'" white-space-pre-line></div>
						</v-card-text>
						</v-card>
				</div>
			</div> -->

			<div style="position:fixed;bottom:0" full-width>
				<v-btn noroundborders color="primary" block nomargin class="height48" @click="fn_checkValidations" style="border-radius:0;">Save</v-btn>
			</div>
		</v-form>

	    <v-dialog v-model="loading" no-click-animation persistent max-width="290">
	      <v-card>
	        <v-card-text class="align_vertical_middle">
	          <v-progress-circular indeterminate color="primary"></v-progress-circular> Please wait...
	        </v-card-text>
	      </v-card>
	    </v-dialog>

	    <dialog-gst-details 
	    	ref="ref_dialogGstDetails" 
	    	:openDialogGstTypes="fn_openDialogGstTypes" 
	    	:openStates="fn_openStates" 
	    	:updatePlaceOfSupply="fn_updatePlaceOfSupply"
	    	:checkAndUpdateGstType="fn_checkAndUpdateGstType"
	    	:openCountries="fn_openCountries"
	    	:updateOverseasCountry="fn_updateOverseasCountry">
	    </dialog-gst-details>

	    <dialog-gst-types
	    	ref="ref_dialogGstTypes"
	    	:gstTypes="gstTypes"
	    	:selectedGstType="Form.accountGstFieldTemp.gstType"
	    	:asignGstType="fn_asignGstType">
	    </dialog-gst-types>

	    <dialog-address 
	    	ref="ref_dialogAddress" 
	    	:openCountries="fn_openCountryDialog" 
	    	:openStates="fn_openStateDialog" 
	    	:updateCountry="fn_updateCountry"
	    	:updateState="fn_updateState"
	    	:saveAddress="fn_saveAddressNew"
			type="ledger"
			:partyName="Form.name">
	    </dialog-address>

	    <!-- fn_draftAction is in draft mixin -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_draftAction" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

	    <!-- <dialog-draft-items ref="ref_dialogDraftItems" :draftItems="Form.draftItems" :importDraft="fn_importDraft" :removeDraftItem="fn_removeDraftItem"></dialog-draft-items> -->

	    <dialog-phone-number ref="ref_dialogPhoneNumber" :phoneNumbers="Form.phoneNumberList" :setPhoneNumber="fn_setPhoneNumber"></dialog-phone-number>

	    <dialog-opening ref="ref_dialogOpening" :amount="Form.openingAmount" :nature="Form.openingNature"></dialog-opening>

		<dialog-selection-list ref="ref_dialogSelectionList" :fnAction="fn_menuItemClick" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

	    <v-snackbar v-model="snackbar" :timeout="2000">{{snackbar_msg}}</v-snackbar>

		<dialog-datepicker ref="ref_dialogDatePicker" :selected="selectedDate" :updateDate="fn_updateDate"></dialog-datepicker>
		<!-- <dialog-dynamic-fields ref="ref_dialogDynamicFields" :saveFields="fn_saveFields" :saveItemFields="fn_saveItemFields"></dialog-dynamic-fields> -->
	    <!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->
	</div>
</template>

<script>
const dialogjs =  require('../dialog').dialogjs;
const menuItem = require('../../../../config.js').configs.menuItem;
const predefinedListIds = require('../../../../config.js').configs.mastersPredefinedLists;
const accountGroupIds = require('../../../../config.js').configs.accountGroupIds;
const draftObj = new Object();
const fixedAccountIds = require('../../../../config.js').configs.fixedAccountIds;

import dialogAddress from '../../../dialogs/dialog_address'
import dialogGstDetails from './dialogs/dialog_gst_details'
import dialogGstTypes from './dialogs/dialog_gst_types'
import dialogOpening from './dialogs/dialog_opening'

import dialogPhoneNumber from './dialogs/dialog_phone_numbers'

import dialogDiscard from '../../../dialogs/dialog_discard'
// import dialogDraftItems from '../../../dialogs/dialog_draft_items'
import {draftMixin} from '../../../draft_mixin'

// import dialogDynamicFields from '../../../dialogs/dialog_dynamic_fields'


// import dialogPermission from '../../../dialogs/dialog_permission';
import dialogSelectionList from '../../../dialogs/dialog_selection_list'
// import Form from '../../../transactions/forms/sale/form.vue';
import componentDynamicFields from '../../../dialogs/component_dynamic_fields'
import dialogDatePicker from '../../../dialogs/dialog_datepicker_dynamic_fields';

const transactionData = require('../../../transactions/datamodel').data.transactionData;

	export default{
		mixins: [draftMixin],
		data(){
			return{
				Form:{"name":null, "accountId":null, "groupTypeId":101, "accountGroupId":null, "accountGroupName":null, 
					//"mobile":null, 
					"email":null, //"phone":null, 
					"addresses":[], 
					// "printDetails": {"printName":null},

					"accountGstFieldTemp":{"gstType":101, "gstNumber":null, "placeOfSupply":null, "placeOfSupplyId":null, "panNumber":null, "aadharNumber":null, "currency":null, "countryId":null, "country":null},

					"gstType":null, "gstNumber":null, "placeOfSupplyId":null, "panNumber":null, "aadharNumber":null, "currency":null, "countryId":null, "country":null,

					// "addressData":{"groupTypeId":103, "addressLine":null, "city":null, "state":null, "countryId":"d87bedca-5bcc-4241-8027-7e16f3b68f18", "country":"India", "pincode":null, "isBillingAddress":true, "isShippingAddress":true, "phone":null},

					"addressData":{"addressId":null, "groupTypeId":null, "addressLine":null, "city":null, "state":null, "countryId":"d87bedca-5bcc-4241-8027-7e16f3b68f18", "country":"India", "pincode":null, "phone":null, "isSameAddress":true},

					// "mobileNumberFields":[{"fieldName":"Mobile Number 1"}],
					// "mobileNumberFields":[],
					// "mobileNumbers":[],

					// "emailFields":[{"fieldName":"Email 1"}],
					// "emails":[],

					"selectedGstType": "Registered Business - Regular",

					"routeId":null, "routeName":null,
					"isSystem":0,
					"primaryMobileNumber":null,
					"otherStates":[],
					"draftItems":[],
					"createdDate":null,
					"modifiedDate":null,
					"phoneNumberList":[],
					"contactInfo":null,
					"isNew":true,
					"billingAddress":[],
					"shippingAddress":[],
					"openingNature":1,
					"openingAmount":null,
					"transactionId":null,
					"msmeUdyamNumber":null,
					"dynamicFields":null,
					"accountGroupCustomFields":[],
					"customFields":null,
					"dynamicFieldsAdditionalData":{}
				},


				loading:false,

				tagId:null,

				dialogStorageId:null,

				draftStorageId:null,

				backButtonPress: false,

				gstTypes:[
					{'id':101, 'title':'Registered Business - Regular'}, 
					{'id':102, 'title':'Registered Business - Composition'}, 
					{'id':103, 'title':'Unregistered Business'}, 
					{'id':104, 'title':'Consumer'}, 
					{'id':105, 'title':'Overseas'}, 
					{'id':106, 'title':'Special Economic Zone'},
					{'id':107, 'title':'Deemed Export'}
				],

    			snackbar:false,
				snackbar_msg:null,

				unwatch:false,
				// loadedFromDraft:false,
				printFieldChanged:false,

				transactionData: JSON.parse(JSON.stringify(transactionData)),
				selectedDate:null,
				dateType:null,
			}
		},
		watch:{
			'$root.selectedLanguage': function(){
				if(!this.Form) return;
				var gstTypeId = this.Form.gstType || (this.Form.accountGstFieldTemp && this.Form.accountGstFieldTemp.gstType);
				if(gstTypeId){
					this.unwatch = true;
					this.Form.selectedGstType = this.fn_getGstTypeName(gstTypeId);
				}
			},
			'Form': {
                handler: function (newVal, oldVal){
                     if(!this.unwatch){
                     	this.fn_saveDraft(this.Form.name);
                     }
                     this.unwatch = false;
                 },
                 deep: true
            }
		},
		components:{
			'dialog-address': dialogAddress,
			'dialog-gst-details': dialogGstDetails,
			'dialog-gst-types': dialogGstTypes,
			'dialog-discard': dialogDiscard,
			// 'dialog-draft-items': dialogDraftItems,
			'dialog-phone-number':dialogPhoneNumber,
			// 'dialog-permission': dialogPermission,
			'dialog-opening': dialogOpening,
			'dialog-selection-list':dialogSelectionList,
			// 'dialog-dynamic-fields':dialogDynamicFields,
			'component-dynamic-fields':componentDynamicFields,
			'dialog-datepicker': dialogDatePicker
		},
		methods:{

			fn_getNameLabel: function(){
				const keyMap = {101:'masters.ledgers.customerName', 102:'masters.ledgers.supplierName', 103:'masters.ledgers.ledgerName', 104:'masters.ledgers.branchDivisionName'};
				return keyMap[this.Form.groupTypeId] ? this.$t(keyMap[this.Form.groupTypeId]) : null;
			},

			// fn_copyName: function (value) {
			// 	console.log(this);
			// 	if(!value && this.printDetails && !this.printDetails.printName){
			// 		this.printFieldChanged = false;	
			// 	}

			// 	if(!this.printFieldChanged){
			// 		this.Form.printDetails.printName = value;
			// 	}
			// },

			fn_groupTypeChange: function(groupTypeId){
				// let formConfig = localStorage.getItem("lastLedgerFormConfig");
				// this.Form.openingNature = 1;
				
				if(groupTypeId == 101){
					!this.Form.openingAmount ? this.Form.openingNature = 1 : '';
					this.fn_updateAccountGroup(accountGroupIds.debtors.id, accountGroupIds.debtors.name, false);
				}
				else if(groupTypeId == 102){
					!this.Form.openingAmount ? this.Form.openingNature = 0 : '';
					this.fn_updateAccountGroup(accountGroupIds.creditors.id, accountGroupIds.creditors.name, false);
				}
				else if(groupTypeId == 104){
					this.fn_updateAccountGroup(accountGroupIds.brandAndDivision.id, accountGroupIds.brandAndDivision.name, false);
				}
				else{
					!this.Form.openingAmount ? this.Form.openingNature = 1 : '';
					this.fn_updateAccountGroup(null, null, true);
					// if(formConfig){
					// 	this.fn_updateAccountGroup(formConfig.accountGroupId, formConfig.accountGroupName, false);
					// }
					// else{
					// 	this.fn_updateAccountGroup(null, null, true);
					// }
				}
				// groupTypeId != 103 ? this.fn_updateAccountGroup(null, null, true) : '';
			},

			fn_openDialogDiscard: function(){
				this.fn_openDialogWeb('web', 'Discard', 'ref_dialogDiscard')
			},

			fn_openingLabel: function(){
				if(!this.Form.openingAmount){
					return 'Opening';
				}
				else{
					if(this.Form.openingNature){
						return 'Opening ('+ this.$root.fn_payOrReceive(1, this.Form.groupTypeId) + ')';
					}
					else{
						return 'Opening ('+ this.$root.fn_payOrReceive(0, this.Form.groupTypeId) + ')';
					}
				}
			},

			fn_openDialogOpening: function(){
				this.fn_openDialogWeb('web', 'Opening', 'ref_dialogOpening');
			},

			fn_setOpening: function(amount, nature){
				this.Form.openingAmount = amount ? amount : null;
				this.Form.openingNature = nature;
				this.fn_closeDialog();
			},

			fn_openRoutes: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Beat/Area/Route";
				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newRoute"};
				viewDialogObject.TopMenu = [menuItemCustom];

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.listId = predefinedListIds.routeListGUID;

				var paramObject = {};
				paramObject.defaultValue = {"id":this.Form.routeId, "name":this.Form.routeName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'listItems', tagId, paramObject, ref);
			},

			fn_updateRoute: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.routeId = selectedValueId;
					this.Form.routeName = selectedValueName;
					this.$forceUpdate();
				}
				else{
					this.Form.routeId = null;
					this.Form.routeName = null;
				}
				this.$forceUpdate();
			},

			// fn_addMobileNumberField: function () {

			// 	let obj = {fieldName:'Mobile Number '+ (this.Form.mobileNumberFields.length+1)}

			// 	this.Form.mobileNumberFields.push(obj);

			// 	this.$forceUpdate();
			// },


			// fn_addEmailField: function () {

			// 	let obj = {fieldName:'Email '+ (this.Form.emailFields.length+1)}

			// 	this.Form.emailFields.push(obj);

			// 	this.$forceUpdate();
			// },

			fn_openDialogGstDetails: function () {
				this.fn_openDialogWeb('web', 'GstFields', 'ref_dialogGstDetails');
			},

			fn_getGstTypeName: function (id) {
				const keyMap = {
					101: 'masters.ledgers.registeredRegular',
					102: 'masters.ledgers.registeredComposition',
					103: 'masters.ledgers.unregisteredBusiness',
					104: 'masters.ledgers.consumer',
					105: 'masters.ledgers.overseas',
					106: 'masters.ledgers.sez',
					107: 'masters.ledgers.deemedExport'
				};
				return keyMap[id] ? this.$t(keyMap[id]) : null;
			},

			fn_openDialogGstTypes: function(){
				this.fn_openDialogWeb('web', 'GstTypes', 'ref_dialogGstTypes');
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				this.$refs[ref].openDialogWeb();
			},

			fn_closeDialogWeb: function () {	
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_editGstDetails: function () {
				this.Form.selectedGstType = this.fn_getGstTypeName(this.Form.gstType);

				this.Form.accountGstFieldTemp.gstType = this.Form.gstType;
				this.Form.accountGstFieldTemp.gstNumber = this.Form.gstNumber;
				this.Form.accountGstFieldTemp.placeOfSupplyId = this.Form.placeOfSupplyId;
				this.Form.accountGstFieldTemp.placeOfSupply = this.Form.placeOfSupply;
				this.Form.accountGstFieldTemp.panNumber = this.Form.panNumber;
				this.Form.accountGstFieldTemp.aadharNumber = this.Form.aadharNumber;
				this.Form.accountGstFieldTemp.currency = this.Form.currency;
				this.Form.accountGstFieldTemp.countryId = this.Form.countryId;
				this.Form.accountGstFieldTemp.country = this.Form.country;

				this.fn_openDialogGstDetails();
			},

			fn_saveGstDetails: function (gstDetailsObj) {

				this.Form.gstType = gstDetailsObj.gstType;
				this.Form.gstNumber = gstDetailsObj.gstNumber ? gstDetailsObj.gstNumber.toUpperCase().trim() : '';
				this.Form.placeOfSupplyId = gstDetailsObj.placeOfSupplyId;
				this.Form.placeOfSupply = gstDetailsObj.placeOfSupply;
				this.Form.panNumber = gstDetailsObj.panNumber ? gstDetailsObj.panNumber.toUpperCase().trim() : '';
				this.Form.aadharNumber = gstDetailsObj.aadharNumber;
				this.Form.currency = gstDetailsObj.currency;
				this.Form.countryId = gstDetailsObj.countryId;
				this.Form.country = gstDetailsObj.country;
				this.$forceUpdate();

				this.fn_closeDialogWeb();
			},

			fn_saveAddressNew: function(addressObj){
				if(!addressObj.addressId){
					addressObj.addressId = this.guid();
				}

				if(this.Form.isNew){
					addressObj.isNewAddress = true;
				}

				if(this.Form.addressData.groupTypeId==101){
					// this.Form.billingAddress = JSON.parse(JSON.stringify(addressObj));
					// if(addressObj.isSameAddress){
					// 	this.Form.shippingAddress = JSON.parse(JSON.stringify(addressObj));
					// 	this.Form.shippingAddress.addressId = this.guid();
					// 	this.Form.shippingAddress.groupTypeId = 102;
					// }
					let itemIndex = this.Form.billingAddress.findIndex(address=>{return address.addressId  == addressObj.addressId});

					if(itemIndex == -1){
						if(!this.Form.billingAddress.length){
							addressObj.isDefault = true;
						}

						this.Form.billingAddress.push(JSON.parse(JSON.stringify(addressObj)));
						if(addressObj.isSameAddress){
							let shipAddress = JSON.parse(JSON.stringify(addressObj));
							shipAddress.addressId = this.guid();
							shipAddress.groupTypeId = 102;

							if(!this.Form.shippingAddress.length){
								shipAddress.isDefault = true;
							}
							
							this.Form.shippingAddress.push(shipAddress);
							// this.Form.shippingAddress.push(JSON.parse(JSON.stringify(addressObj)));
							// this.Form.shippingAddress.addressId = this.guid();
							// this.Form.shippingAddress.groupTypeId = 102;
						}
					}
					else{
						this.Form.billingAddress[itemIndex] = JSON.parse(JSON.stringify(addressObj));
					}
					
					
				}
				else{
					// this.Form.shippingAddress = JSON.parse(JSON.stringify(addressObj));
					let itemIndex = this.Form.shippingAddress.findIndex(address=>{return address.addressId  == addressObj.addressId});
					if(itemIndex == -1){
						if(!this.Form.shippingAddress.length){
							addressObj.isDefault = true;
						}

						this.Form.shippingAddress.push(JSON.parse(JSON.stringify(addressObj)));
					}
					else{
						this.Form.shippingAddress[itemIndex] = JSON.parse(JSON.stringify(addressObj));
					}
					
				}

				this.fn_closeDialogWeb();
			},

			// fn_saveAddress: function(addressObj, type, copyData){
			// fn_saveAddress: function(addressObj){

			// 	this.fn_closeDialogWeb();

			// 	//setting group type id
			// 	// if(addressObj.isBillingAddress && !addressObj.isShippingAddress){
			// 	// 	addressObj.groupTypeId = 101;
			// 	// }
			// 	// else if(!addressObj.isBillingAddress && addressObj.isShippingAddress){
			// 	// 	addressObj.groupTypeId = 102;
			// 	// }
			// 	// else{
			// 	// 	addressObj.groupTypeId = 103;
			// 	// }

			// 	// if(!addressObj.isBillingAddress && !addressObj.isShippingAddress){
			// 	// 	return;
			// 	// }

			// 	// let self = this;
			// 	// setTimeout(function(){
			// 	// 	self.$vuetify.goTo(".addressListItem", self.scrollOptions);
			// 	// },100);

			// 	console.log(JSON.stringify(addressObj));

			// 	if(!addressObj.addressId){
			// 		// alert(!addressObj.addressId);
			// 		// !addressObj.addressId ? addressObj.addressId = this.guid() : '';
			// 		addressObj.addressId = this.guid();
			// 		console.log(JSON.stringify(addressObj));
			// 		this.Form.addresses.push(JSON.parse(JSON.stringify(addressObj)));

			// 		if(addressObj.isSameAddress){
			// 			let shippingAddressObj = JSON.parse(JSON.stringify(addressObj));
			// 			shippingAddressObj.addressId = this.guid();
			// 			shippingAddressObj.groupTypeId = 102;
			// 			this.Form.addresses.push(shippingAddressObj);
			// 		}
			// 	}
			// 	else{
			// 		console.log(JSON.stringify(this.Form.addresses));
			// 		let itemIndex = this.Form.addresses.findIndex(item=>{
			// 			return addressObj.addressId == item.addressId;
			// 		});

			// 		console.log(JSON.stringify(addressObj));
			// 		// this.Form.addresses.splice(itemIndex, 1, addressObj);
			// 		this.Form.addresses[itemIndex] = JSON.parse(JSON.stringify(addressObj));


			// 		// alert(addressObj.isSameAddress);
			// 		if(addressObj.groupTypeId == 101 && addressObj.isSameAddress){
			// 			var shippingAddressObj = JSON.parse(JSON.stringify(addressObj));
			// 			shippingAddressObj.groupTypeId = 102;

			// 			if(this.Form.addresses.length == 1){
			// 				shippingAddressObj.addressId = this.guid();
			// 				this.Form.addresses.push(shippingAddressObj);
			// 			}
			// 			else{
			// 				let itemIndex = this.Form.addresses.findIndex(item=>{
			// 					return item.groupTypeId == 102;
			// 				});
			// 				// let itemIndex = this.Form.addresses.findIndex(item=>{
			// 				// 	return item.groupTypeId == 102;
			// 				// });
			// 				// this.Form.addresses.splice(itemIndex, 1, shippingAddressObj);
			// 				this.Form.addresses[itemIndex] = JSON.parse(JSON.stringify(shippingAddressObj));	
			// 			}
			// 		}
			// 	}

			// 	console.log(JSON.stringify(this.Form.addresses));

			// 	this.fn_assignAddress();

			// },

			fn_assignAddress: function(){
				this.Form.billingAddress = [];
				this.Form.shippingAddress = [];
				for(let i=0; i<this.Form.addresses.length; i++){
					if(this.Form.addresses[i].groupTypeId == 101){
						// this.Form.billingAddress = JSON.parse(JSON.stringify(this.Form.addresses[i]));
						this.Form.billingAddress.push(JSON.parse(JSON.stringify(this.Form.addresses[i])));
					}
					else{
						// this.Form.shippingAddress = JSON.parse(JSON.stringify(this.Form.addresses[i]));	
						this.Form.shippingAddress.push(JSON.parse(JSON.stringify(this.Form.addresses[i])));
					}
				}
			},

			fn_editAddress: function (address, groupTypeId) {
				// if(addressObj.groupTypeId == 101){
				// 	addressObj.isBillingAddress = true;
				// 	addressObj.isShippingAddress = false;
				// }
				// else if(addressObj.groupTypeId == 102){
				// 	addressObj.isBillingAddress = false;
				// 	addressObj.isShippingAddress = true;
				// }
				// else{
				// 	addressObj.isBillingAddress = true;
				// 	addressObj.isShippingAddress = true;
				// }

				// let addressObj = groupTypeId == 101 ? JSON.parse(JSON.stringify(this.Form.billingAddress)) : JSON.parse(JSON.stringify(this.Form.shippingAddress));
				let addressObj = JSON.parse(JSON.stringify(address))

				console.log(addressObj);

				this.Form.addressData.isSameAddress = false;
				this.Form.addressData.addressId = addressObj.addressId;
				this.Form.addressData.addressLine = addressObj.addressLine;
				this.Form.addressData.city = addressObj.city;
				this.Form.addressData.country = addressObj.country;
				addressObj.countryId ? this.Form.addressData.countryId = addressObj.countryId : '';
				this.Form.addressData.groupTypeId = addressObj.groupTypeId;
				// this.Form.addressData.isBillingAddress = addressObj.isBillingAddress;
				// this.Form.addressData.isShippingAddress = addressObj.isShippingAddress;
				this.Form.addressData.pincode = addressObj.pincode;
				this.Form.addressData.state = addressObj.state;
				addressObj.stateId ? this.Form.addressData.stateId = addressObj.stateId : '';

				this.Form.addressData.phone = addressObj.phone;

				this.Form.addressData.isDefault = addressObj.isDefault;

				this.Form.addressData.billerShipperName = addressObj.billerShipperName;

				// if(groupTypeId == 101 && this.Form.shippingAddress){
				// 	if(this.fn_mergeAddress(101) == this.fn_mergeAddress(102)){
				// 		this.Form.addressData.isSameAddress = true;
				// 	}
				// }
				
				this.fn_openDialogAddress();
			},


			// fn_editAddress: function (addressObj) {
			// 	if(addressObj.groupTypeId == 101){
			// 		addressObj.isBillingAddress = true;
			// 		addressObj.isShippingAddress = false;
			// 	}
			// 	else if(addressObj.groupTypeId == 102){
			// 		addressObj.isBillingAddress = false;
			// 		addressObj.isShippingAddress = true;
			// 	}
			// 	else{
			// 		addressObj.isBillingAddress = true;
			// 		addressObj.isShippingAddress = true;
			// 	}

			// 	this.Form.addressData.addressId = addressObj.addressId;
			// 	this.Form.addressData.addressLine = addressObj.addressLine;
			// 	this.Form.addressData.city = addressObj.city;
			// 	this.Form.addressData.country = addressObj.country;
			// 	addressObj.countryId ? this.Form.addressData.countryId = addressObj.countryId : '';
			// 	this.Form.addressData.groupTypeId = addressObj.groupTypeId;
			// 	this.Form.addressData.isBillingAddress = addressObj.isBillingAddress;
			// 	this.Form.addressData.isShippingAddress = addressObj.isShippingAddress;
			// 	this.Form.addressData.pincode = addressObj.pincode;
			// 	this.Form.addressData.state = addressObj.state;
			// 	addressObj.stateId ? this.Form.addressData.stateId = addressObj.stateId : '';

			// 	this.Form.addressData.phone = addressObj.phone;
				
			// 	this.fn_openDialogAddress();
			// },

			fn_mergeAddress: function(addressObj, addressGroupTypeId){

				// let addressObj = addressGroupTypeId == 101 ? this.Form.billingAddress : this.Form.shippingAddress;
				// let addressObj = address;

				if(!addressObj){
					return '';
				}

				let billerShipperName, addressLine, city, state, pincode, phone, country;

				addressObj.billerShipperName ? billerShipperName = addressObj.billerShipperName + ', ' : billerShipperName = '';
				addressObj.addressLine ? addressLine = addressObj.addressLine + ', ' : addressLine = '';
				addressObj.city ? city = addressObj.city + ', ' : city = '';
				addressObj.state ? state = addressObj.state + ', ' : state = '';
				addressObj.phone ? phone = addressObj.phone + ', ' : phone = '';
				addressObj.pincode ? pincode = addressObj.pincode + ' - ' : pincode = '';
				addressObj.country ? country = addressObj.country : country = '';

				return billerShipperName + addressLine + city + state + phone + pincode + country;
			},

			// fn_mergeAddress: function(addressObj){

			// 	let addressLine, city, state, pincode, country;

			// 	addressObj.addressLine ? addressLine = addressObj.addressLine + ', ' : addressLine = '';
			// 	addressObj.city ? city = addressObj.city + ', ' : city = '';
			// 	addressObj.state ? state = addressObj.state + ', ' : state = '';
			// 	addressObj.pincode ? pincode = addressObj.pincode + ', ' : pincode = '';
			// 	addressObj.country ? country = addressObj.country : country = '';

			// 	return addressLine + city + state + pincode + country;
			// },

			fn_removeGstDetails: function () {
				this.Form.accountGstFieldTemp = {"gstType":101, "gstNumber":null, "placeOfSupply":null, "placeOfSupplyId":null, "panNumber":null, "aadharNumber":null, "currency":null, "countryId":null, "country":null}
				this.Form.gstType = null;
				this.Form.gstNumber = null;
				this.Form.placeOfSupply = null;
				this.Form.placeOfSupplyId = null;
				this.Form.panNumber = null;
				this.Form.aadharNumber = null;
				this.Form.currency = null;
				this.Form.countryId = null;
				this.Form.country = null;
				this.Form.selectedGstType = this.fn_getGstTypeName(101);
				this.$forceUpdate();
				this.fn_closeDialogWeb();
			},

			// fn_removeAddress: function (addressId, index) {
			// 	this.Form.addresses.splice(index, 1);				
			// },

			fn_removeAddress: function (index, groupTypeId) {
				if(groupTypeId==101){
					// this.Form.billingAddress = null;
					this.Form.billingAddress.splice(index, 1);
				}
				else{
					// this.Form.shippingAddress = null;
					this.Form.shippingAddress.splice(index, 1);
				}
				// let itemIndex = this.Form.addresses.findIndex(item=>{
				// 	return item.groupTypeId == groupTypeId;
				// });
				// this.Form.addresses.splice(itemIndex, 1);
			},

			fn_asignGstType: function (gstType) {
				this.fn_closeDialogWeb();
				this.Form.selectedGstType = this.fn_getGstTypeName(gstType.id);
				this.Form.accountGstFieldTemp.gstType = gstType.id;
			},

			fn_checkAndUpdateGstType: function (gstDetailsObj) {
				this.Form.selectedGstType = this.fn_getGstTypeName(gstDetailsObj.gstType);

				if(gstDetailsObj.gstType!=105){
					this.Form.accountGstFieldTemp.currency = null;
					this.Form.accountGstFieldTemp.countryId = null;
					this.Form.accountGstFieldTemp.country = null;
				}
				else{
					this.Form.accountGstFieldTemp.gstNumber = null;
					this.Form.accountGstFieldTemp.panNumber = null;
					this.Form.accountGstFieldTemp.placeOfSupplyId = null;
					this.Form.accountGstFieldTemp.placeOfSupply = null;
				}

				if(gstDetailsObj.gstType!=103){
					this.Form.accountGstFieldTemp.aadharNumber = null;
				}
				
				if(gstDetailsObj.gstType==103 || gstDetailsObj.gstType==104){
					this.Form.accountGstFieldTemp.gstNumber = null;
				}

				this.$forceUpdate();
				this.fn_saveGstDetails(this.Form.accountGstFieldTemp);
			},

			// fn_openAccountGroupsDialog: function(ref){

			// 	let viewDialogObject = { ToolbarTitle:"Account Group", fnName:"AccountGroupDialog", action:"new", ref:ref, dbSearch:true };

			// 	if(this.Form.groupTypeId == 101){
			// 		viewDialogObject.accountGroupIds = this.Form.accountGroupId ? [accountGroupIds.debtors.id, this.Form.accountGroupId] : [accountGroupIds.debtors.id];
			// 	}
			// 	else if(this.Form.groupTypeId == 102){
			// 		viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id];
			// 	}
			// 	else if(this.Form.groupTypeId == 104){
			// 		viewDialogObject.accountGroupIds = [accountGroupIds.brandAndDivision.id];
			// 	}

			// 	if(this.Form.accountGroupId && this.Form.accountGroupName){
			// 		viewDialogObject.selectedItem = {"itemId":this.Form.accountGroupId, "itemName":this.Form.accountGroupName};
			// 	}

			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Account Group', 'ref_dialogSelectionList');
			// 	// this.fn_openStateDialog('android', 'State', ref);
			// },

			fn_openAccountGroupsDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Account Group";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				// viewDialogObject.accountGroupIds = this.Form.groupTypeId == 101 ? [accountGroupIds.debtors.id] : this.Form.groupTypeId == 102 ? [accountGroupIds.creditors.id] : this.Form.groupTypeId == 104 ? [accountGroupIds.brandAndDivision.id] : null;	

				if(this.Form.groupTypeId == 101){
					// viewDialogObject.accountGroupIds = this.$route.query.accountgroup ? [this.$route.query.accountgroup.id] : [accountGroupIds.debtors.id];
					viewDialogObject.accountGroupIds = this.Form.accountGroupId ? [accountGroupIds.debtors.id, this.Form.accountGroupId] : [accountGroupIds.debtors.id];
				}
				else if(this.Form.groupTypeId == 102){
					viewDialogObject.accountGroupIds = [accountGroupIds.creditors.id];
				}
				else if(this.Form.groupTypeId == 104){
					viewDialogObject.accountGroupIds = [accountGroupIds.brandAndDivision.id];
				}

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.accountGroupId && this.Form.accountGroupName){
					paramObject.defaultValue = {"id":this.Form.accountGroupId, "name":this.Form.accountGroupName};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accountgroups', tagId, paramObject, ref);
			},

			// fn_openStates: function(ref){

			// 	let viewDialogObject = { ToolbarTitle:"State", fnName:"StateDialog" };
			// 	if(ref=='ref_dialogAddress_state'){
			// 		if(this.Form.addressData.stateId && this.Form.addressData.state){
			// 			viewDialogObject.selectedItem = {"itemId":this.Form.addressData.stateId, "itemName":this.Form.addressData.state};
			// 		}
			// 	}
			// 	else{
			// 		if(this.Form.accountGstFieldTemp.placeOfSupplyId && this.Form.accountGstFieldTemp.placeOfSupply){
			// 			viewDialogObject.selectedItem = {"itemId":this.Form.accountGstFieldTemp.placeOfSupplyId, "itemName":this.Form.accountGstFieldTemp.placeOfSupply};
			// 		}
			// 	}
			// 	viewDialogObject.ref = ref;
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'State', 'ref_dialogSelectionList');
			// 	// this.fn_openStateDialog('android', 'State', ref);
			// },

			fn_openStates: function(ref){
				this.fn_openStateDialog('android', 'State', ref);
			},

			fn_openStateDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select State";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(ref=='ref_dialogAddress_state'){
					if(this.Form.addressData.stateId && this.Form.addressData.state){
						paramObject.defaultValue = {"id":this.Form.addressData.stateId, "name":this.Form.addressData.state};
					}
				}
				else{
					if(this.Form.accountGstFieldTemp.placeOfSupplyId && this.Form.accountGstFieldTemp.placeOfSupply){
						paramObject.defaultValue = {"id":this.Form.accountGstFieldTemp.placeOfSupplyId, "name":this.Form.accountGstFieldTemp.placeOfSupply};
					}
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
			},

			// fn_openCountries: function(ref){

			// 	let viewDialogObject = { ToolbarTitle:"Country", fnName:"CountryDialog", dbSearch:true };
			// 	if(ref=='ref_dialogAddress_country'){
			// 		if(this.Form.addressData.countryId && this.Form.addressData.country){
			// 			viewDialogObject.selectedItem = {"itemId":this.Form.addressData.countryId, "itemName":this.Form.addressData.country};
			// 		}
			// 	}
			// 	else{
			// 		if(this.Form.accountGstFieldTemp.countryId && this.Form.accountGstFieldTemp.country){
			// 			viewDialogObject.selectedItem = {"itemId":this.Form.accountGstFieldTemp.countryId, "itemName":this.Form.accountGstFieldTemp.country};
			// 		}
			// 	}
			// 	viewDialogObject.ref = ref;
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'Country', 'ref_dialogSelectionList');
			// },

			fn_openCountries: function(ref, type){
				if(type=='address')
					this.fn_openCountryDialog('android', 'Country', ref, this.Form.addressData.countryId, this.Form.addressData.country);
				else
					this.fn_openCountryDialog('android', 'Country', ref, this.Form.accountGstFieldTemp.countryId, this.Form.accountGstFieldTemp.country);
			},

			fn_openCountryDialog: function (platform, name, ref, countryId, country) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				//dialogObj.data = null;
				dialogObj.platform = platform;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Country";
				viewDialogObject.TopMenu = [menuItem.new];
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(countryId && country){
					paramObject.defaultValue = {"id":countryId, "name":country};
				}

				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'country', tagId, paramObject, ref);
			},

			

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				if(ref.indexOf('dialog') != -1){
					let key = ref.substring(0, ref.lastIndexOf('_'));
					let dialogRef = this.$refs[key];
		
					if(Array.isArray(dialogRef.$refs[ref])){
		          		dialogRef.$refs[ref][0].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
		          	}
		          	else{
		          		dialogRef.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
		          	}
				}
				else if(ref.indexOf("ref_componentDynamicFields") != -1){
					this.$refs['ref_componentDynamicFields'].$refs[ref][0].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);	
				}
				else{
					this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
				}
			},

			fn_updateAccountGroup: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountGroupId = selectedValueId;
		        	this.Form.accountGroupName = selectedValueName;
		        	this.errors.remove('account group');
					this.Form.dynamicFields = null,
					this.Form.accountGroupCustomFields = [];
					this.Form.customFields = null;
					this.fn_getAccountGroupSettings();

		        	// if(selectedValueId != this.Form.accountGroupId && this.Form.accountGroupId == accountGroupIds.runningCustomer.id){
		        	// 	this.Form.gstType = 104;
		        	// 	this.Form.placeOfSupplyId = this.$root.CurrentBusiness.StateID;
		        	// 	this.Form.placeOfSupply = this.$root.CurrentBusiness.State;
		        	// 	this.Form.gstNumber = null;
		        	// 	this.Form.panNumber = null;
		        	// 	this.Form.country = null;
		        	// }
				}
				else{
					this.Form.accountGroupId = null;
		        	this.Form.accountGroupName = null;
				}
			},

			fn_updateState: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.addressData.stateId = selectedValueId;
		        	this.Form.addressData.state = selectedValueName;
				}
				else{
					this.Form.addressData.stateId = null;
		        	this.Form.addressData.state = null;
				}
			},

			fn_updateCountry: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.addressData.countryId = selectedValueId;
		        	this.Form.addressData.country = selectedValueName;
		        	this.Form.addressData.stateId = null;
		        	this.Form.addressData.state = null;
		        	selectedValueName != 'India' ? this.fn_getOtherStates(selectedValueName) : '';
				}
				else{
					this.Form.addressData.countryId = null;
		        	this.Form.addressData.country = null;
				}
			},

			fn_getOtherStates: function(country){
				let filterObject = {};
				filterObject.country = country;

				let self = this;
				this.getFilterData('OtherStates', null, filterObject, 
					{
						onSuccess: function(response){
							console.log(response);
							if(response){
								self.Form.otherStates = JSON.parse(response);
							}
							else{
								self.Form.otherStates = [];
							}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_updateOverseasCountry: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountGstFieldTemp.countryId = selectedValueId;
		        	this.Form.accountGstFieldTemp.country = selectedValueName;
				}
				else{
					this.Form.accountGstFieldTemp.countryId = null;
		        	this.Form.accountGstFieldTemp.country = null;
				}
			},

			fn_updatePlaceOfSupply: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.accountGstFieldTemp.placeOfSupplyId = selectedValueId;
		        	this.Form.accountGstFieldTemp.placeOfSupply = selectedValueName;
		        	this.errors.remove('gstdetails.PlaceofSupply');
				}
				else{
					this.Form.accountGstFieldTemp.placeOfSupplyId = null;
		        	this.Form.accountGstFieldTemp.placeOfSupply = null;
				}
			},

			// fn_getBottomMenu: function (tagId) {
			// 	var bottomMenu = {"BottomMenu": [menuItem.save, menuItem.reset, menuItem.contacts, menuItem.help]};
			// 	this.setBottomMenu(tagId, bottomMenu, 
			// 		{
			// 			onSuccess: function (response) {
			// 				console.log(response);
			// 			},
			// 			onError: function (error) {
			// 				console.log(error);
			// 			}
			// 		}
			// 	)
			// },

			fn_closeDialog: function (tagId) {
				// dialogjs.fn_closeDialog(this, tagId);
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_checkValidations: function(){
				if(this.Form.gstNumber){
					this.Form.gstNumber = this.Form.gstNumber.replace(/\s+/g, "");
				}
				
			    this.$validator.validateAll().then((result) => {
			        if (result) {
						if(this.Form.dynamicFields && this.Form.dynamicFields.items && this.Form.dynamicFields.items.length){
							this.$refs['ref_componentDynamicFields'].$validator.validateAll('fields').then((result)=>{
								if(result){
									this.fn_post();
								}
							})	
						}
						else{
							this.fn_post();
						}
			        	// if(this.Form.groupTypeId != 103 && !this.Form.gstType){
			        	// 	this.showToast('Add Gst Details')
			        	// 	this.$vuetify.goTo('.gstdetails', this.scrollOptions);
			        	// 	return;
			        	// }
						
			        	// this.fn_post();
			        }
			        else{
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			fn_addAddress: function (groupTypeId) {
				this.Form.addressData = {"addressId":null, "groupTypeId":groupTypeId, "addressLine":null, "city":null, "state":null, "countryId":"d87bedca-5bcc-4241-8027-7e16f3b68f18", "country":"India", "pincode":null, "phone":null, "isSameAddress":!this.Form.shippingAddress.length && groupTypeId == 101 ? true : false, "isDefault":false, "billerShipperName":null};
				if(this.Form.gstType == 105){
					this.Form.addressData.countryId = this.Form.countryId;
					this.Form.addressData.country = this.Form.country;
				}
				this.fn_openDialogAddress();
			},

			fn_openDialogAddress: function(){
				this.fn_openDialogWeb('web', 'Address', 'ref_dialogAddress');
			},

			fn_closeAddressDialog: function () {
				// this.fn_closeDialogWeb();
				this.$refs['ref_dialogAddress'].closeDialogWeb();
			},

			fn_saveLocal: function(dataObj){
				var self = this;
				this.postData('Ledger', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	let status = JSON.parse(response);
				          	if(status) {
					          	// self.fn_cleanUp();
					          	if(self.Form.openingAmount){
					          		self.fn_postOpening();
					          	}
					          	else{
					          		if(self.Form.transactionId){
					          			self.fn_deleteTransaction(function(status){
					          				if(status){
					          					self.fn_cleanUp();
					          				}
					          			})
					          		}
					          		else{
					          			self.fn_cleanUp();
					          		}
					          	}

				          	}
				          	else {
				          		self.hideLoading();
				          		self.showToast("Already exists with this name");
				          	}
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				        }
					}
		        );
			},

			fn_deleteTransaction: function(callback){
	            let self = this;
	            let filterObject = {};
	            filterObject.transactionListId = [40003];
	            this.postFilterData('deleteTransaction', this.Form.transactionId, filterObject, {

	                onSuccess: function(response){
	                    
	                    console.log(response);

	                    callback(JSON.parse(response));

	                }, 
	                onError: function(error){
	                    console.log(error);
	                    let status = JSON.parse(error);
	                    if(status && status.itemsCount){
	                        let msg = 'Unable to delete as this item already in use under [' + status.items.join(', ') + ']';
	                        self.showToast(msg);
	                    }
	                }
	            });
	        },

			fn_cleanUp: function () {
				// this.loadedFromDraft = false;

				if(this.$route.query.ls){
					let data = {};
					data.type = this.$route.query.type ? this.$route.query.type : 'ledger';
					data.id = this.Form.accountId;
					data.name = this.Form.name;
					data.accountGroupId = this.Form.accountGroupId;
					localStorage.setItem('newItem', JSON.stringify(data));
					// setting up storage to close dialog if (dlg means dialog should not close) not in the query
					if(!this.$route.query.dlg){
						localStorage.setItem('closeDialog', 1);	
					}
				}

				// setting up last saved configuration to remember
				// let formConfig = {};
				// formConfig.groupTypeId = this.Form.groupTypeId;
				// formConfig.accountGroupId = this.Form.accountGroupId;
				// formConfig.accountGroupName = this.Form.accountGroupName;
				// localStorage.setItem('lastLedgerFormConfig', formConfig);

				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){

					if(localStorage.getItem("ledgers_items_state")){
						let obj = JSON.parse(localStorage.getItem("ledgers_items_state"));
						obj.itemId = self.Form.accountId;
						localStorage.setItem("ledgers_items_state",JSON.stringify(obj));
					}

					self.hideLoading();
					self.fn_goBack(true);
					// if(self.$route.query && self.$route.query.routeToDisplay){
					// 	self.$router.replace({path:'/masters/accounts/ledgers/items/'+self.Form.accountId, query:{"showMenu":true}})
					// }
					// else{
					// 	self.$router.go(-1);	
					// }
				});
			},

			// fn_generateMobileNumbers: function () {
			// 	this.Form.mobile = '';

			// 	for(let i=0; i<this.Form.mobileNumbers.length; i++){
			// 		if(!this.Form.mobileNumbers[i]){
			// 			this.Form.mobileNumbers.splice(i, 1);
			// 		}
			// 	}

			// 	if(this.Form.mobileNumbers.length){
			// 		for(let index=0; index<this.Form.mobileNumbers.length; index++){
			// 			if(this.Form.mobileNumbers.length-1 != index){
			// 				this.Form.mobileNumbers[index] ? this.Form.mobile += this.Form.mobileNumbers[index]+', ':'';
			// 			}
			// 			else{
			// 				this.Form.mobileNumbers[index] ? this.Form.mobile += this.Form.mobileNumbers[index]:'';
			// 			}
			// 		}
			// 	}
			// },

			// fn_appendMobileNumbers: function (mobileNumberString) {
			// 	let Numbers = [];
			// 	this.Form.mobileNumbers = [];
			// 	this.Form.mobileNumberFields = [];
			// 	mobileNumberString.indexOf(', ') != -1 ? Numbers = mobileNumberString.split(', ') : Numbers.push(mobileNumberString);
				

			// 	for(let index=0; index<Numbers.length; index++){

			// 		let obj = {fieldName:'Mobile Number '+ (this.Form.mobileNumberFields.length+1)}

			// 		this.Form.mobileNumberFields.push(obj);

			// 		this.Form.mobileNumbers.push(Numbers[index]);
			// 	}
			// },

			// fn_generateEmails: function () {
			// 	this.Form.email = '';

			// 	for(let i=0; i<this.Form.emails.length; i++){
			// 		if(!this.Form.emails[i]){
			// 			this.Form.emails.splice(i, 1);
			// 		}
			// 	}

			// 	if(this.Form.emails.length){
			// 		for(let index=0; index<this.Form.emails.length; index++){
			// 			if(this.Form.emails.length-1 != index){
			// 				this.Form.emails[index] ? this.Form.email += this.Form.emails[index]+', ':'';
			// 			}
			// 			else{
			// 				this.Form.emails[index] ? this.Form.email += this.Form.emails[index]:'';
			// 			}
			// 		}
			// 	}
			// },

			// fn_appendEmails: function (emailString) {
			// 	let Emails = [];
			// 	this.Form.emails = [];
			// 	this.Form.emailFields = [];
			// 	emailString.indexOf(',') != -1 ? Emails = emailString.split(',') : Emails.push(emailString);


			// 	for(let index=0; index<Emails.length; index++){

			// 		let obj = {fieldName:'Email '+ (this.Form.emailFields.length+1)}

			// 		this.Form.emailFields.push(obj);
			// 		this.Form.emails.push(Emails[index]);
			// 	}
			// },

			fn_clearFields: function () {
				this.Form.mobile = null;
				this.Form.email = null;
				// this.Form.phone = null;

				this.Form.addresses = [];
				this.Form.selectedGstType = null;
				this.Form.routeId = null;
				this.Form.routeName = null;
				this.$forceUpdate();
			},

			fn_post: function(){

				this.showLoading("Please wait...");
				// !this.Form.accountId ? this.Form.accountId = this.guid() : '';
				if(!this.Form.accountId){
					this.Form.accountId = this.guid();
					// this.Form.createdDate = new Date();
					this.Form.createdDate = this.$root.fn_getLocalDateFormat();
				}

				// this.Form.modifiedDate = new Date();
				this.Form.modifiedDate = this.$root.fn_getLocalDateFormat();
				
				this.Form.name = this.Form.name.trim();

				if(this.Form.groupTypeId != 101){
					this.Form.routeId = null;
					this.Form.routeName = null;
				}

				if(this.Form.groupTypeId == 103){
					this.fn_clearFields();
				}

				// if(this.Form.groupTypeId != 103){
				// 	this.fn_generateMobileNumbers();
				// 	this.fn_generateEmails();
				// }
				// else{
				// 	this.fn_clearFields();
				// }

				// this.Form.printDetails =  JSON.stringify(this.Form.printDetails);

				if(!this.Form.gstType){
					this.Form.gstType = this.Form.groupTypeId == 101 ? 104 : this.Form.groupTypeId == 102 ? 103 : null;
				}
				// !this.Form.gstType ? this.Form.gstType = 104 : '';

				this.Form.addresses = [];

				// if(this.Form.billingAddress){
				// 	this.Form.addresses.push(this.Form.billingAddress);
				// }

				// if(this.Form.shippingAddress){
				// 	this.Form.addresses.push(this.Form.shippingAddress);
				// }
				for(let i=0; i<this.Form.billingAddress.length; i++){
					this.Form.addresses.push(this.Form.billingAddress[i]);
				}

				for(let i=0; i<this.Form.shippingAddress.length; i++){
					this.Form.addresses.push(this.Form.shippingAddress[i]);
				}

				// this.Form.accountSections = [{"accountSectionId":"b4217191-b230-4d9f-8833-6722c4973c5a","sectionId":"f953853d-116d-4a09-a14c-77ec2976f670","sectionName":"Other Details", "accountId":this.Form.accountId, "orderNumber":1}];
				// this.Form.accountFields = [{"accountFieldId":"98e30174-3dc4-45a3-904b-894cd45cb4f4","accountSectionId":"b4217191-b230-4d9f-8833-6722c4973c5a","accountGroupFieldId":"8d8db020-d201-4c86-9f55-98a7fbef9046", "accountId":this.Form.accountId, "sectionId":"f953853d-116d-4a09-a14c-77ec2976f670","orderNumber":1,"fieldId":"ebc863d6-6954-b70a-b7fa-7a22fb3168f1","fieldName":"PO No.","fieldValue":"abc","fieldDataType":"text","accountLedgerId":null,"listItemId":null},{"accountFieldId":"9bc97ec4-36d6-48cd-9594-b1e383dedb79","accountSectionId":"b4217191-b230-4d9f-8833-6722c4973c5a","accountGroupFieldId":"68615c7e-642e-4323-972b-0aff3e43df07","sectionId":"f953853d-116d-4a09-a14c-77ec2976f670","orderNumber":2,"fieldId":"86723266-62de-4aac-9511-89743e6b4b7a","fieldName":"PO Date","fieldValue":"2026-05-01T18:30:33.0","fieldDataType":"dateTime","accountLedgerId":null,"listItemId":null}];

				//Inserting 
					// dynamic/custom section to transactionSections
					// dynamic/custom fields to transactionFields

				this.Form.accountSections = [];
				this.Form.accountFields = [];

				if(this.Form.dynamicFields && this.Form.dynamicFields.section && this.Form.dynamicFields.items && this.Form.dynamicFields.items.length){
					let sectionObj = {};
					sectionObj.accountSectionId = this.guid();
					sectionObj.accountId = this.Form.accountId;
					sectionObj.sectionId = this.Form.dynamicFields.section.sectionId;
					sectionObj.sectionName = this.Form.dynamicFields.section.sectionName;
					// sectionObj.orderNumber = index+1;
					sectionObj.orderNumber = this.Form.dynamicFields.section.orderNumber;

					this.Form.accountSections.push(sectionObj);
					// if(this.Form.customFields && this.Form.customFields.items.length){

					let self = this;

					this.Form.dynamicFields.items.forEach(function (fieldItem, index) {

						// item.items.forEach(function (fieldItem, index) {

							let fieldObj = {};
							fieldObj.accountFieldId	= self.guid();
							fieldObj.accountId = self.Form.accountId;
							fieldObj.accountSectionId = sectionObj.accountSectionId;
							fieldObj.accountGroupFieldId = fieldItem.accountGroupFieldId;
							fieldObj.sectionId = fieldItem.sectionId;
							fieldObj.orderNumber = index+1;
							fieldObj.fieldId = fieldItem.fieldId;
							fieldObj.fieldName = fieldItem.displayName;
							fieldObj.fieldValue = fieldItem.value;
							fieldObj.fieldDataType = fieldItem.fieldType;

							fieldObj.accountLedgerId = fieldItem.accountLedgerId ? fieldItem.accountLedgerId : null;
							fieldObj.listItemId = fieldItem.listItemId ? fieldItem.listItemId : null;

							self.Form.accountFields.push(fieldObj);
						// })
					})

					// }
				}

				console.log(this.Form);
				this.fn_saveLocal(this.Form);
			},

			fn_get: function(itemId, copyData){
				var self = this;
				this.unwatch = true;
				this.Form.isNew = false;
				this.getData('Ledger', itemId, 
					{
						onSuccess: function(response){
							console.log(response);
							
							let item = JSON.parse(response);
							
							self.unwatch = true;
							self.Form.accountId = item.accountId;
							self.Form.groupTypeId = item.groupTypeId;
							self.Form.name = item.name;				
							self.Form.accountGroupId = item.accountGroupId;
							self.Form.accountGroupName = item.accountGroupName;

							self.Form.routeId = item.routeId;
							self.Form.routeName = item.routeName;

							self.Form.email = item.email;
							// self.Form.phone = item.phone;

							self.Form.addresses = JSON.parse(JSON.stringify(item.addresses));

							if(item.gstType){
								self.Form.selectedGstType = self.fn_getGstTypeName(item.gstType);
								self.Form.gstType = item.gstType;
								self.Form.gstNumber = item.gstNumber;
								self.Form.placeOfSupplyId = item.placeOfSupplyId;
								self.Form.placeOfSupply = item.placeOfSupply;
								self.Form.panNumber = item.panNumber;
								self.Form.aadharNumber = item.aadharNumber;
								self.Form.currency = item.currency;
								self.Form.countryId = item.countryId;
								self.Form.country = item.country;
							}

							self.Form.primaryMobileNumber = item.primaryMobileNumber;
							
							// item.mobile ? self.fn_appendMobileNumbers(item.mobile) : '';
							// item.email ? self.fn_appendEmails(item.email) : '';

							// item.printDetails ? self.Form.printDetails = JSON.parse(item.printDetails) : '';

							self.Form.isSystem = item.isSystem;
							self.Form.msmeUdyamNumber = item.msmeUdyamNumber;

							if(copyData){
					          	self.Form.accountId=null;
					          	self.Form.isSystem = 0;
					   //        	self.snackbar = true;
								// self.snackbar_msg = "Data copied."
								self.showToast("Ledger copied");

								if(self.Form.addresses && self.Form.addresses.length){
									for(let i=0; i<self.Form.addresses.length; i++){
										self.Form.addresses[i].addressId = self.guid();
										delete self.Form.addresses[i].baseAccountId;
									}

									console.log(JSON.stringify(self.Form.addresses));
								}
					        }
					        else{
					        	if(item.opening){
									self.Form.openingAmount = Math.abs(item.opening.amount);
									self.Form.openingNature = item.opening.amountType;
									self.Form.transactionId = item.opening.transactionId;
								}
					        }

					        self.fn_assignAddress();

							if(item.accountSections && item.accountFields && item.accountFields.length){
								self.fn_getAccountGroupSettings(item.accountFields);
							}
							else{
								self.fn_getAccountGroupSettings();
							}

					        self.$root.fn_copyFormObject(self.Form, self.formId);

				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
		        );
			},

			fn_clearForm: function(){
				this.unwatch = true;
				this.Form = {"name":null, "accountId":null, "groupTypeId":101, "accountGroupId":null, "accountGroupName":null, 
				// "mobile":null, 
				"email":null, //"phone":null, 
				// "printDetails": {"printName":null},

					"accountGstFieldTemp":{"gstType":null, "gstNumber":null, "placeOfSupply":null, "placeOfSupplyId":null, "panNumber":null, "currency":null, "countryId":null, "country":null},

					"gstType":null, "gstNumber":null, "placeOfSupplyId":null, "panNumber":null, "currency":null, "countryId":null, "country":null,

					// "addressData":{"groupTypeId":103, "addressLine":null, "city":null, "state":null, "countryId":"d87bedca-5bcc-4241-8027-7e16f3b68f18", "country":"India", "pincode":null, "isBillingAddress":true, "isShippingAddress":true, "phone":null},

					"addressData":{"addressId":null, "groupTypeId":103, "addressLine":null, "city":null, "state":null, "countryId":"d87bedca-5bcc-4241-8027-7e16f3b68f18", "country":"India", "pincode":null, "phone":null, "isSameAddress":true},

					// "mobileNumberFields":[],
					// "mobileNumbers":[],

					// "emailFields":[{"fieldName":"Email 1"}],
					// "emails":[],

					"selectedGstType": "Registered Business - Regular",
					"routeId":null, "routeName":null,
					"isSystem":0,
					"primaryMobileNumber":null,
					"draftItems":[],
					"createdDate":null,
					"modifiedDate":null,
					"isNew":true,
					// "billingAddress":null,
					// "shippingAddress":null
					"billingAddress":[],
					"shippingAddress":[]
				}

				if(this.$route.query.groupTypeId){
					this.Form.groupTypeId = this.$route.query.groupTypeId;
				}

				this.fn_groupTypeChange(this.Form.groupTypeId);
				
				this.$validator.reset();
			},

			fn_menuItemClick: function(tagId, menuId, menuAction){
				// tagId id form future use
				// menuId id form future use
				this.backButtonPress = false;

				if(menuAction=='save'){
					this.fn_checkValidations();
				}
				else if(menuAction=='new'){
					this.$router.push({path:'/masters/accounts/groups/new', query:{tagId:this.guidWeb(), ls:1}})
				}
				else if(menuAction=='newRoute'){
					this.$router.push({path:'/masters/lists/'+predefinedListIds.routeListGUID+'/items/new', query:{tagId:this.guidWeb(), listTitle:"Beat/Area/Route", ls:1, type:'route'}});
				}
				else if(menuAction=='contacts'){
					this.fn_showContactList();
				}
				else if(menuAction=='dynamicAccountField'){
					this.fn_newDynamicAccount()
				}
				else if(menuAction=='newListItem'){
					this.$router.push({path:'/masters/lists/'+this.Form.dynamicFieldsAdditionalData.listId+'/items/new', query:{tagId:this.guidWeb(), listTitle:this.Form.dynamicFieldsAdditionalData.listName, ls:1, type:'listItem'}});
				}
				else if(menuAction=='reset'){
					this.fn_resetForm();
				}
			},

			fn_resetForm: function () {
				this.unwatch = true;
				// this.loadedFromDraft = false;

				if(this.Form.accountId){
					this.fn_get(this.Form.accountId);
				}
				else{
					this.fn_clearForm();
				}
				
				let self = this;
				this.fn_removeDraft(this.draftStorageId, function(){
					console.log("draft deleted");
					// self.showToast("Item deleted from draft");
				});
			},

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.ToolbarTitle = "Account Ledger";
				viewObject.TopMenu = [menuItem.save];
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_openDialogPhoneNumbers: function(){
				this.fn_openDialogWeb('web', 'PhoneNumbers', 'ref_dialogPhoneNumber');
			},

			fn_showContactList: function () {
				let self = this;
				this.showContactList({
						onSuccess: function(response){
				          	console.log(response);
				          	if(response){
						        self.Form.contactInfo = JSON.parse(response);

						        // self.Form.primaryMobileNumber = contactInfo.mobileArray[0];

						        // contactInfo.mobileArray.splice(0, 1);

						        // let mobileNumbers = contactInfo.mobileArray.join(', ');
						        // let emails = contactInfo.emailArray.join(', ');

						        
						        // mobileNumbers ? self.fn_appendMobileNumbers(mobileNumbers) : '';
						        // emails ? self.fn_appendEmails(emails) : '';

						        // contactInfo.other && contactInfo.other.length ? self.Form.phone = contactInfo.other[0] : '';

						        self.Form.phoneNumberList = [];

						        if(self.Form.contactInfo.mobileArray.length == 1){
						        	self.Form.primaryMobileNumber = self.Form.contactInfo.mobileArray[0];
						        	self.Form.email = self.Form.contactInfo.emailArray[0];
						        	self.Form.contactInfo.name ? self.Form.name = self.Form.contactInfo.name : '';
						        	// self.Form.printDetails.printName = self.Form.name;
						        }
						        else if(self.Form.contactInfo.mobileArray.length > 1){
						        	self.Form.phoneNumberList = self.Form.contactInfo.mobileArray;
						        	self.fn_openDialogPhoneNumbers();
						        }

						        self.errors.remove('name');
				      		}
				        }, 
				        onError: function(error){
				          console.log(error);
				        }
					}
				);
			},

			fn_setPhoneNumber: function(phoneNumber){
				this.Form.primaryMobileNumber = phoneNumber;
				this.Form.email = this.Form.contactInfo.emailArray[0];
	        	this.Form.contactInfo.name ? this.Form.name = this.Form.contactInfo.name : '';
	        	// this.Form.printDetails.printName = this.Form.name;
				this.fn_closeDialog();
			},

			fn_setNewItem: function(){
				if(localStorage.getItem('newItem')){

					let itemData = JSON.parse(localStorage.getItem('newItem'));

					switch (itemData.type) {
						case "accountGroup":
					    	this.fn_updateAccountGroup(itemData.id, itemData.name, false);
					        break;
					    case "route":
					    	this.fn_updateRoute(itemData.id, itemData.name, false);
					        break;
						case "ledger":
							this.$refs['ref_componentDynamicFields'].$refs[ref][0].fn_updateAccountLedger(itemData.id, itemData.name, false);
							// this.$refs['ref_componentDynamicFields'][0].fn_updateAccountLedger(itemData.id, itemData.name, false);
							break;
						case "listItem":
							this.$refs['ref_componentDynamicFields'].$refs[ref][0].fn_updateLinkedItem(itemData.id, itemData.name, false)	
							break;
					    default:
					    	console.log("condition not matched");
					}

					localStorage.removeItem('newItem');
				}

				this.Form.isNew ? this.$root.fn_copyFormObject(this.Form, this.formId) : '';
			},

			fn_goBack: function(checkBackBtn){
				!checkBackBtn ? this.backButtonPress = true : '';
				if(checkBackBtn && this.$route.query && this.$route.query.routeToDisplay){
					this.$router.replace({path:'/masters/accounts/ledgers/items/'+this.Form.accountId, query:{"showMenu":true}})
				}
				else{
					this.$router.go(-1);
				}
				// this.$router.go(-1);
			},

			// fn_openPermissionDialog: function(permissionType){
		    //     this.$root.permissionType = permissionType;
		    //     this.fn_openDialogWeb('web', 'Permission', 'ref_dialogPermission');
		    // },

		    fn_postOpening: function(){

		    	this.transactionData.transactionId = this.Form.transactionId;

				//only in case of new transaction
				if(!this.transactionData.transactionId){
					this.transactionData.transactionId = this.guid();
					this.transactionData.createdDate = new Date();
				}

				this.transactionData.modifiedDate = new Date();

				this.transactionData.partyId = this.Form.accountId;

				let amount = this.Form.openingAmount ? this.Form.openingAmount : 0;
				this.transactionData.amount = amount  //debit or credit amount
				this.transactionData.roundedAmount = Math.round(amount); //or creditTotal amount
				this.transactionData.status = 1;
				this.transactionData.transactionListId = 40003;
				this.transactionData.refDate = null;

				//subtracted 1 day from opening date as we are adding opening one day less than user selected opening date
				// let od = new Date(JSON.parse(JSON.stringify(this.openingDate)));
				let od = new Date(JSON.parse(JSON.stringify(this.$root.CurrentBusiness.OpeningDate)));
	            od.setDate(od.getDate()-1);
				this.transactionData.transactionDate = new Date(od);

				let grossAmount = this.roundUpto2Decimals(amount);

				if((this.Form.groupTypeId == 101 && this.Form.openingNature == 0) || (this.Form.groupTypeId == 102 && this.Form.openingNature == 1)){
					this.transactionData.grossAmount = -grossAmount;
				}
				else{
					this.transactionData.grossAmount = grossAmount;
				}

				this.transactionData.onAccount = null;

				let postObj = {};
				postObj = JSON.parse(JSON.stringify(this.transactionData));

				let ledgerAccountAmount = amount;

				//Preparing Object for transaction ledger table
				let transactionLedgerObj = {};

				transactionLedgerObj.transactionLedgerId = this.guid();
				transactionLedgerObj.accountLedgerId = this.Form.accountId;
				transactionLedgerObj.orderNumber = 1;
				transactionLedgerObj.amount = amount;
				transactionLedgerObj.amountType = this.Form.openingNature;

				postObj.transactionLedgers = [];
				postObj.transactionLedgers.push(transactionLedgerObj);
				
				//Preparing Object for ledger accounts table
				let ledgerAccountObj = {};

				ledgerAccountObj.ledgerAccountId = this.guid();
				ledgerAccountObj.accountId =  this.Form.accountId;
				ledgerAccountObj.amount =  this.Form.openingNature == 1 ? ledgerAccountAmount : -ledgerAccountAmount;
				ledgerAccountObj.amountType =  this.Form.openingNature;

				postObj.ledgerAccounts = [];
				postObj.ledgerAccounts.push(ledgerAccountObj);

				postObj.sortDate = this.$moment(this.transactionData.transactionDate).format('YYYY-MM-DD');

				console.log(JSON.stringify(postObj));
				this.fn_saveOpeningLocal(postObj);
			},

			fn_saveOpeningLocal: function(dataObj){
				var self = this;
				this.postData('Transaction', dataObj, 
					{
						onSuccess: function(response){
				          	console.log(response);
				          	self.fn_cleanUp();
				        },
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				        }
					}
		        );
			},

			fn_setDefaultAddress: function(index){
				for(let i=0; i<this.Form.shippingAddress.length; i++){
					this.Form.shippingAddress[i].isDefault = false;
				}
				this.Form.shippingAddress[index].isDefault = true;
			},

			// fn_getAccountGroupData: function(accountFields){
			// 	var self = this;
			// 	this.getData('AccountGroups', this.Form.accountGroupId, 
			// 		{
			// 			onSuccess: function(response){
			// 				console.log(response);
			// 				let accountGroupData = JSON.parse(response);
			// 				self.Form.accountGroupCustomFields = [];
			// 				for(let i=0; i<accountGroupData.accountGroupSections.length; i++){
			// 					let customFieldObj = {};
			// 					customFieldObj.section = accountGroupData.accountGroupSections[i];
			// 					customFieldObj.fields = [];
			// 					for(let j=0; j<accountGroupData.accountGroupFields.length; j++){
			// 						let fieldObj= {};
			// 						if(customFieldObj.section.sectionId == accountGroupData.accountGroupFields[j].sectionId){
			// 							customFieldObj.fields.push(accountGroupData.accountGroupFields[j]);
			// 						}
			// 					}
			// 					self.Form.accountGroupCustomFields.push(customFieldObj);
			// 				}
			// 				self.fn_bindDynamicItemFields(self.Form.accountGroupCustomFields[0].section.sectionId, accountFields);
			// 			},
			// 			onError: function(error){
			// 				console.log(error);
			// 			}
			// 		}
			// 	);
			// },

			fn_getAccountGroupSettings: function(accountFields){
				var self = this;
				this.getData('GetAccountGroupSetting', this.Form.accountGroupId, 
					{
						onSuccess: function(response){
							console.log(response);
							let accountGroupData = response ? JSON.parse(response) : null;
							if(accountGroupData && accountGroupData.isCustomized && accountGroupData.accountGroupSections && accountGroupData.accountGroupSections.length && accountGroupData.accountGroupFields && accountGroupData.accountGroupFields.length){
								self.fn_bindFields(accountGroupData, accountFields);
							}
							else{
								// inheritance
								self.fn_getAccountGroupFields(accountFields);
							}
						},
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			// inheritance
			fn_getAccountGroupFields: function(accountFields){
				var self = this;
				this.getData('GetAccountGroupSectionsAndFields', this.Form.accountGroupId, 
					{
						onSuccess: function(response){
							console.log(response);
							let data = response ? JSON.parse(response) : null;
							if(data && data.accountGroupSections && data.accountGroupSections.length && data.accountGroupFields && data.accountGroupFields.length){
								self.fn_bindFields(data, accountFields);
							}
						},
						onError: function(error){
							console.log(error);
						}
					}
				);
			},

			fn_bindFields: function(accountGroupData, accountFields){
				this.Form.accountGroupCustomFields = [];
				for(let i=0; i<accountGroupData.accountGroupSections.length; i++){
					let customFieldObj = {};
					customFieldObj.section = accountGroupData.accountGroupSections[i];
					customFieldObj.fields = [];
					for(let j=0; j<accountGroupData.accountGroupFields.length; j++){
						let fieldObj= {};
						if(customFieldObj.section.sectionId == accountGroupData.accountGroupFields[j].sectionId){
							customFieldObj.fields.push(accountGroupData.accountGroupFields[j]);
						}
					}
					this.Form.accountGroupCustomFields.push(customFieldObj);
				}
				this.fn_bindDynamicItemFields(this.Form.accountGroupCustomFields[0].section.sectionId, accountFields);
			},

			fn_bindDynamicItemFields: function (sectionId, accountFields) {

				this.Form.dynamicFields = {"section":null, "items":[], "additionalData":{}, "accountGroupId":null, "accountGroupName":null, "isItemDetails":true};

				// let itemIndex = this.Form.productData.items[0].customFields.findIndex(item=>{
				//     return item.section.sectionId == sectionId;
				// });
				let customFields = [];
				if(this.Form.accountGroupCustomFields && this.Form.accountGroupCustomFields.length){
					customFields = this.Form.accountGroupCustomFields;
				}
				// if(this.settings.transactionTypeId == 10001 || this.settings.transactionTypeId == 10002 || this.settings.transactionTypeId == 10003 || this.settings.transactionTypeId == 10004 || this.settings.transactionTypeId == 10005){
				// 	customFields = this.Form.productData.items[0].customFields;
				// }
				// else{
				// 	customFields = this.Form.productDataModel.customFields;
				// }

				let itemIndex = customFields.findIndex(item=>{
					return item.section.sectionId == sectionId;
				});

				// this.Form.dynamicFields.section = this.Form.itemSectionAndFields.accountGroupSections.find(item=>{
				// 	return sectionId == item.sectionId;
				// });

				this.Form.dynamicFields.section = customFields[itemIndex].section;

				// if(this.Form.itemSectionAndFields && this.Form.itemSectionAndFields.transactionTypeFields && this.Form.itemSectionAndFields.transactionTypeFields.length){
				this.Form.dynamicFields.items = this.Form.accountGroupCustomFields[itemIndex].fields.filter(item=>{
					if(sectionId == item.sectionId){
						// item.additionalData = typeof(item.additionalData) == 'string' ? JSON.parse(item.additionalData) : item.additionalData;
						item.additionalData && typeof(item.additionalData) == 'string' ? item.additionalData = JSON.parse(item.additionalData) : '';
						item.value = null;
						item.listItemId = null;
						item.accountLedgerId = null;

						if(item.fieldType == 'yes/no'){
							item.value = item.additionalData.defaultValue;
						}

						if(item.fieldType == 'choice'){
							item.value = item.additionalData.defaultChoice;
						}
						
						return true;
					}
				});
				// }
				

				if(itemIndex!=-1){

					for(let i=0; i<this.Form.dynamicFields.items.length; i++){

						let defaultField = this.Form.dynamicFields.items[i];
						defaultField.additionalData && typeof(defaultField.additionalData) == 'string' ? defaultField.additionalData = JSON.parse(defaultField.additionalData) : '';
						for(let j=0; j<customFields[itemIndex].fields.length; j++){

							let existingField = customFields[itemIndex].fields[j];

							if(defaultField.fieldId == existingField.fieldId){
								defaultField.value = existingField.value;

								if(defaultField.fieldType == 'linkedItem'){
									defaultField.listItemId = existingField.listItemId;
								}
								else if(defaultField.fieldType == 'accountItem'){
									defaultField.accountLedgerId = existingField.accountLedgerId;
								}

							}

						}

					}

				}
				

				console.log(JSON.stringify(this.Form.dynamicFields));

				// assigning value on edit
				if(accountFields && accountFields.length){
					this.Form.dynamicFields.items.forEach(function(fieldItem, index){
						accountFields.forEach(function(accountField){
							// if(fieldItem.sectionId == accountField.sectionId && fieldItem.fieldId == accountField.fieldId){
							if(fieldItem.fieldId == accountField.fieldId){
								fieldItem.value = accountField.fieldValue;
								fieldItem.accountLedgerId = accountField.accountLedgerId;
								fieldItem.listItemId = accountField.listItemId;
							}
						})
					})
				}
				// this.fn_saveItemFields(this.Form.dynamicFields);

				// this.fn_openDialogDynamicFields();
			},

			fn_saveItemFields: function (fieldsObj) {
				let data = JSON.parse(JSON.stringify(fieldsObj));

				console.log(JSON.stringify(data));

				//finding if details already exist
				// let itemIndex = this.Form.productData.items[0].customFields.findIndex(item=>{
				//     return item.section.sectionId == data.section.sectionId;
				// })

				// this.Form.productData.items[0].customFields = data;
				// if(this.settings.transactionTypeId == 10001 || this.settings.transactionTypeId == 10002 || this.settings.transactionTypeId == 10003 || this.settings.transactionTypeId == 10004 || this.settings.transactionTypeId == 10005){
				// 	this.Form.productData.items[0].customFields = data;
				// }
				// else{
				// 	this.Form.productDataModel.customFields = data;
				// }

				this.$nextTick(() => {
					this.Form.customFields = data;
				});

				// if(itemIndex==-1){
				//     this.Form.productData.items[0].customFields.push(data);
				// }
				// else{
				//     this.Form.productData.items[0].customFields[itemIndex] = data;
				//     this.$forceUpdate();
				// }

				console.log(JSON.stringify(this.Form.customFields));

				// this.fn_closeDialog();
			},

			fn_openDatePicker: function (type, date) {
				let self = this;
				this.dateType = type;
				this.selectedDate = date ? date : this.$root.fn_getLocalDateFormat();
				setTimeout(function () {
					self.fn_openDialogWeb('web', 'DatePicker', 'ref_dialogDatePicker');
				})
			},

			fn_updateDate: function (value) {
				this.$refs['ref_componentDynamicFields'].fn_updateDynamicDate(value, this.dateType);
				// this.$refs['ref_dialogDynamicFields'].fn_updateDynamicDate(value, this.dateType);
				this.fn_closeDialog();
			},

			fn_openAccountLedgers: function (platform, name, ref, itemId, itemName, accountGroups) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};

				let action = "newledger";
				viewDialogObject.ToolbarTitle = "Select Ledger";
				viewDialogObject.hiddenAccounts = [fixedAccountIds.runningCustomer.id];
				this.Form.dynamicFields.accountGroupId ? action = "dynamicAccountField" : "";
				viewDialogObject.isBottomMenu = false;
				viewDialogObject.accountGstTypes = null;

				if(accountGroups && accountGroups.length){
					viewDialogObject.accountGroups = JSON.parse(JSON.stringify(accountGroups));
				}

				// let isDynamicField = ref.indexOf("ref_dialogDynamicFields_accountLedger") == -1 ? false : true;

				// if(this.Form.transactionTypeData.importExport && this.Form.transactionTypeData.importExportTransactionAccountId && !isDynamicField){
				// 	viewDialogObject.accountGstTypes = [accountGstType.overseas.id, accountGstType.sez.id];
				// }
				// else{
				// 	viewDialogObject.accountGstTypes = [accountGstType.registered.id, accountGstType.composition.id, accountGstType.unregistered.id, accountGstType.consumer.id, accountGstType.deemed.id];
				// }

				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":action};
				viewDialogObject.TopMenu = [menuItemCustom];

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'accounts', tagId, paramObject, ref);
			},

			fn_newDynamicAccount: function(){
				let groupTypeId = null;
				if(this.Form.dynamicFields.accountGroupId == accountGroupIds.debtors.id)
					groupTypeId = 101;
				else if(this.Form.dynamicFields.accountGroupId == accountGroupIds.creditors.id || this.Form.dynamicFields.accountGroupId == accountGroupIds.transporter.id)
					groupTypeId = 102;
				else if(this.Form.dynamicFields.accountGroupId == accountGroupIds.brandAndDivision.id)
					groupTypeId = 104;
				else
					groupTypeId = 103;

				// setting up default account group to be selected
				let data = {};
				data.type = 'accountGroup';
				data.id = this.Form.dynamicFields.accountGroupId;
				data.name = this.Form.dynamicFields.accountGroupName;
				localStorage.setItem('newItem', JSON.stringify(data));

				this.$router.push({
					path:'/masters/accounts/ledgers/items/new', 
					query:{
						tagId:this.guidWeb(), 
						groupTypeId: groupTypeId, 
						ls:1
					}
				})
				
			},

			fn_openListItems: function (platform, name, ref, itemId, itemName, listId, listName) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;


				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select Item";
				let menuItemCustom = {"MenuID":null, "Icon":null, "Text":"New", "Action":"newListItem"};
				
				this.Form.dynamicFieldsAdditionalData.listId = listId;
				this.Form.dynamicFieldsAdditionalData.listName = listName;
				
				viewDialogObject.TopMenu = [menuItemCustom];

				viewDialogObject.isBottomMenu = false;
				viewDialogObject.listId = listId;

				var paramObject = {};
				paramObject.defaultValue = {"id":itemId, "name":itemName};

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'listItems', tagId, paramObject, ref);
			},

			// fn_bindDynamicFields: function (sectionId) {

			// 	this.Form.dynamicFields = {"section":null, "items":[], "additionalData":{}, "accountGroupId":null, "accountGroupName":null};

			// 	let itemIndex = this.Form.customFields.findIndex(item=>{
			// 		return item.section.sectionId == sectionId;
			// 	});

			// 	this.Form.dynamicFields.section = this.Form.transactionTypeData.transactionSections.find(item=>{
			// 		return sectionId == item.sectionId;
			// 	});

			// 	this.Form.dynamicFields.items = this.Form.transactionTypeData.transactionTypeFields.filter(item=>{
			// 		if(sectionId == item.sectionId){
			// 			item.additionalData = typeof(item.additionalData) == 'string' ? JSON.parse(item.additionalData) : item.additionalData;
			// 			item.value = null;
			// 			item.listItemId = null;
			// 			item.accountLedgerId = null;

			// 			if(item.fieldType == 'yes/no'){
			// 				item.value = item.additionalData.defaultValue;
			// 			}

			// 			if(item.fieldType == 'choice'){
			// 				item.value = item.additionalData.defaultChoice;
			// 				// item.value = item.additionalData.choices[0];
			// 			}

			// 			// if(item.fieldType == 'dateTime'){
			// 			// 	item.value = new Date();
			// 			// }
						
			// 			return true;
			// 		}
			// 	});

			// 	if(itemIndex!=-1){

			// 		for(let i=0; i<this.Form.dynamicFields.items.length; i++){

			// 			let defaultField = this.Form.dynamicFields.items[i];

			// 			for(let j=0; j<this.Form.customFields[itemIndex].items.length; j++){

			// 				let existingField = this.Form.customFields[itemIndex].items[j];

			// 				if(defaultField.fieldId == existingField.fieldId){
			// 					defaultField.value = existingField.value;

			// 					if(defaultField.fieldType == 'linkedItem'){
			// 						defaultField.listItemId = existingField.listItemId;
			// 					}
			// 					else if(defaultField.fieldType == 'accountItem'){
			// 						defaultField.accountLedgerId = existingField.accountLedgerId;
			// 					}

			// 				}

			// 			}

			// 		}

			// 	}
				

			// 	console.log(JSON.stringify(this.Form.dynamicFields));

			// 	this.fn_openDialogDynamicFields();
			// },

			// fn_openDialogDynamicFields: function () {
			// 	this.fn_openDialogWeb('web', 'DynamicFields', 'ref_dialogDynamicFields');
			// },

			// fn_saveFields: function (fieldsObj) {
			// 	let data = JSON.parse(JSON.stringify(fieldsObj));

			// 	console.log(JSON.stringify(data));

			// 	//finding if details already exist
			// 	let itemIndex = this.Form.customFields.findIndex(item=>{
			// 		return item.section.sectionId == data.section.sectionId;
			// 	})

			// 	if(itemIndex==-1){
			// 		this.Form.customFields.push(data);
			// 	}
			// 	else{
			// 		this.Form.customFields[itemIndex] = data;
			// 		this.$forceUpdate();
			// 	}

			// 	let self = this;
			// 	setTimeout(function () {
			// 		self.$vuetify.goTo('#section_'+data.section.sectionId, self.scrollOptions);

			// 		if(data.section.sectionId == self.ewayBillDetailSection.sectionId){
			// 			self.Form.hideEwayOption = true;
			// 		}
			// 		else{
			// 			let index = itemIndex != -1 ? itemIndex : self.Form.customFields.length-1
			// 			self.fn_showHideDynamicFieldOption(index, true);
			// 		}

			// 		self.fn_saveDraft(self.Form.partyName);
			// 	},100)
			// 	this.fn_closeDialog();
			// },

			// fn_removeFields: function (index, sectionId) {
			// 	if(this.ewayBillDetailSection.sectionId == sectionId){
			// 		this.Form.hideEwayOption = false;
			// 	}
			// 	else{
			// 		this.fn_showHideDynamicFieldOption(index, false);
			// 	}
			// 	this.Form.customFields.splice(index, 1);
			// },

			// fn_showHideDynamicFieldOption: function(index, hideOption){
			// 	for(let j=0; j<this.Form.dynamicMenuItems.length; j++){
			// 		if(this.Form.dynamicMenuItems[j].sectionId == this.Form.customFields[index].section.sectionId){
			// 			this.Form.dynamicMenuItems[j].hideOption = hideOption;
			// 			this.$forceUpdate();
			// 		}
			// 	}
			// },

			// fn_saveItemFields: function (fieldsObj) {
			// 	let data = JSON.parse(JSON.stringify(fieldsObj));

			// 	console.log(JSON.stringify(data));

			// 	//finding if details already exist
			// 	// let itemIndex = this.Form.productData.items[0].customFields.findIndex(item=>{
			// 	//     return item.section.sectionId == data.section.sectionId;
			// 	// })

			// 	// this.Form.productData.items[0].customFields = data;
			// 	if(this.settings.transactionTypeId == 10001 || this.settings.transactionTypeId == 10002 || this.settings.transactionTypeId == 10003 || this.settings.transactionTypeId == 10004 || this.settings.transactionTypeId == 10005){
			// 		this.Form.productData.items[0].customFields = data;
			// 	}
			// 	else{
			// 		this.Form.productDataModel.customFields = data;
			// 	}

			// 	// if(itemIndex==-1){
			// 	//     this.Form.productData.items[0].customFields.push(data);
			// 	// }
			// 	// else{
			// 	//     this.Form.productData.items[0].customFields[itemIndex] = data;
			// 	//     this.$forceUpdate();
			// 	// }

			// 	console.log(JSON.stringify(this.Form.productData.items[0].customFields));

			// 	// this.fn_closeDialog();
			// },

			// fn_removeItemFields: function (index) {
			// 	this.Form.productData.items[0].customFields.splice(index, 1);
			// },
		},
		mounted: function(){
			
			this.$validator.extend('verify_gstnumber', {
			    validate: value => {
			        // var strongRegex = new RegExp("^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$");
					var strongRegex = new RegExp("^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[a-zA-Z]{1}[0-9a-zA-Z]{1})+$");

					var strongRegexGov = new RegExp("^[0-9]{2}[A-Za-z]{4}[0-9]{5}[A-Za-z]{1}[0-9]{1}[A-Za-z]{2}$");
			        
					// for godaddy gst number
					var usaTaxIdRegex = new RegExp("^[0-9]{4}[a-zA-Z]{3}[0-9]{5}[a-zA-Z]{2}[0-9]{1}$");

					// for gram panchayat gst number
					var gramPanchayatRegex = new RegExp("^[0-9]{2}[a-zA-Z0-9]{5}[0-9]{4}[a-zA-Z]{1}[0-9]{1}[a-zA-Z0-9]{2}$");
					// let isFormValid = strongRegex.test(value);
			        return strongRegex.test(value) || strongRegexGov.test(value) || usaTaxIdRegex.test(value) || gramPanchayatRegex.test(value);
			    }
			});


			this.$validator.extend('verify_pannumber', {
			    validate: value => {
			        var regpan = /^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/;
			        return regpan.test(value);
			    }
			});

			// this.$validator.extend('nospace', {
			//     getMessage: field => 'Space characters are not allowed.',
			//     validate: value => {
			//         var regpan = /^\S+$/;
			//         return regpan.test(value);
			//     }
			// });

			var self = this;

			if(this.$route.query && this.$route.query.tagId){//in case of new form
				this.formId = this.$route.query.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}
			else if(this.$route.params && this.$route.params.tagId){//in case of edit form
				this.formId = this.$route.params.tagId;
				this.draftStorageId = 'draft_master_'+this.formId;
				this.dialogStorageId = 'dialog_'+this.formId;
			}

			if(this.$route.query && this.$route.query.groupTypeId && this.$route.query.groupTypeId != "null"){
				this.unwatch = true;
				this.Form.groupTypeId = Number(this.$route.query.groupTypeId);
			}

			// this.unwatch = true;
			// this.fn_groupTypeChange(this.Form.groupTypeId);

			var formsArray = [];
			if(localStorage.getItem('accountforms')){
				formsArray = JSON.parse(localStorage.getItem('accountforms'));
			}
			formsArray.push(this.formId);
			localStorage.setItem('accountforms', JSON.stringify(formsArray));

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;
			// window.js_globals.fn_getBottomMenu = this.fn_getBottomMenu;
			// window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;

			this.fn_showWebView();

			if(localStorage.getItem('closeDialog')){
				this.fn_closeDialog();
				localStorage.removeItem('closeDialog');
			}
			else{
				dialogjs.fn_checkAndShowOpenDialogs(this);
			}

			if((this.$route.query && this.$route.query.tagId) || (this.$route.params && this.$route.params.tagId)){
				
				this.fn_setFormDataFromDraft(function(draft){

					if(draft){
						self.Form = JSON.parse(draft.formData);

			            // if((self.$route.query && self.$route.query.draft) || (self.$route.params && self.$route.params.tagId)){
			            //   self.loadedFromDraft = true;
			            // }
					}
					// else{
					// 	self.fn_getAccountGroupData();
					// }

		            // self.$route.query.tagId ? self.fn_checkDraftItems('Ledger', true) : '';

				});
			}

			let formElement = document.getElementsByClassName("form-element")[0];

			formElement.addEventListener("submit", function(e){
			    e.preventDefault();
			});

			setTimeout(function(){self.fn_setNewItem()},300);

			// this.fn_setDraftData('Master', 'Ledger');
			this.fn_setDraftData('temp', 'Ledger');
		},

		beforeRouteEnter (to, from, next) {
		  	next(vm => {
		  		vm.enableToolbar();
		  		
		  		let itemId = null;
		  		let copyData = false;

		  		//edit from display view 
		  		if((from.params && from.params.tagId) && (to.query && !to.query.tagId)){
					itemId = from.params.tagId;
		  		}

		  		//edit from list view
		  		else if((from.name=='ledgerItems' || from.name=="invoicePreviewSettings") && (to.params && to.params.tagId)){
		  			itemId = to.params.tagId;
		  		}

		  		//copy data
		  		if(to.query && to.query.copy){
		  			if(from.name == 'ledgerItems'){ //copy from list view
		  				itemId = to.query.itemId;
		  			}
		  			else if(from.name == 'ledgerDisplay'){ //copy from display view
		  				itemId = from.params.tagId;
		  			}
		  			copyData = true;
		  		}

		  		//checking if draft exist
		  		// vm.fn_isDraft(function(isDraft){
		  		// 	if(itemId && !isDraft){
		  		// 		vm.fn_get(itemId, copyData);
		  		// 	}
		  		// })

		  		if(itemId){
	  				vm.fn_get(itemId, copyData);
	  			}
				else{
					vm.unwatch = true;
					vm.fn_groupTypeChange(vm.Form.groupTypeId);
				}
		  	})
		},
		beforeRouteUpdate (to, from, next) {
			this.enableToolbar();
			
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			var existingForm = false;
			if(dialogData && dialogData.length){
				var openForms = JSON.parse(localStorage.getItem('accountforms'));
				for(var i=0; i<openForms.length; i++){
					if(openForms[i]==to.query.tagId){
						existingForm = true;
						dialogjs.fn_checkAndCloseOpenDialogs(this);
						break;
					}
				}
				existingForm ? next(false) : next(true);
			}
			else{
				next();
			}
	    },
	    beforeRouteLeave (to, from, next) {
			var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){

				if(this.backButtonPress){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
					next(false);
				}
				else{
					// this.$root.fn_deleteFormObject();
					this.fn_saveDraft(this.Form.name);
					next(true);
				}
			}
			else{
				// if(this.askToDiscard){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				if(this.fn_showDialogDiscard()){
					this.fn_openDialogDiscard();
					next(false);
				}
				else{
					this.fn_clearData('accountforms', function(){
						next();
					})
				}
				// if(this.loadedFromDraft || (this.$root.fn_getFormObject(this.formId) && !this.$root.fn_deepEqual(this.Form, JSON.parse(this.$root.fn_getFormObject(this.formId))))){
				// 	this.fn_openDialogDiscard();
				// 	next(false);
				// }
				// else{
				// 	this.$root.fn_deleteFormObject(this.formId);
				// 	!this.askToDiscard ? this.fn_removeDraft(this.draftStorageId, null, -1) : '';
				// 	localStorage.removeItem('accountforms')
				// 	next();	
				// }
			}
	    }
	}

</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/form.vue